var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgOctagon2(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 2256,
    height: 1244,
    viewBox: "0 0 2256 1244",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.0144928,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2078.37 876.358L1876.05 1131.47C1870.23 1138.81 1860.26 1141.41 1851.61 1137.85L1550.45 1014.05C1545.33 1011.95 1541.25 1007.91 1539.1 1002.81L1357.52 573.533C1355.82 569.524 1355.41 565.088 1356.35 560.837L1444.13 162.169C1445.82 154.462 1451.7 148.356 1459.33 146.364L1734.09 74.7025C1741.73 72.7107 1749.84 75.1688 1755.08 81.0656L2026.39 386.076C2029.28 389.328 2031.09 393.399 2031.57 397.725L2082.79 861.002C2083.4 866.503 2081.81 872.022 2078.37 876.358ZM1879.18 1133.96C1872.26 1142.69 1860.39 1145.78 1850.09 1141.55L1548.93 1017.75C1542.84 1015.25 1537.98 1010.44 1535.41 1004.37L1353.83 575.091C1351.82 570.319 1351.33 565.037 1352.44 559.977L1440.22 161.309C1442.24 152.133 1449.23 144.865 1458.33 142.494L1733.08 70.832C1742.17 68.4608 1751.82 71.3871 1758.07 78.4072L2029.38 383.417C2032.82 387.289 2034.98 392.135 2035.55 397.286L2086.77 860.562C2087.49 867.111 2085.6 873.681 2081.51 878.844L1879.18 1133.96Z",
    fill: "url(#paint0_linear_52_1127)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.0289855,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2039.58 894.254L1825.33 1136.34C1819.15 1143.33 1809.09 1145.4 1800.65 1141.41L1508.27 1003.49C1503.26 1001.13 1499.38 996.876 1497.49 991.666L1339.88 557.577C1338.39 553.473 1338.22 549.007 1339.39 544.8L1447.5 154.807C1449.6 147.211 1455.78 141.435 1463.51 139.847L1739.98 83.0032C1747.7 81.4159 1755.66 84.2853 1760.59 90.434L2013.8 406.139C2016.53 409.545 2018.13 413.717 2018.38 418.076L2044.82 879.135C2045.13 884.669 2043.25 890.103 2039.58 894.254ZM1828.33 1138.99C1820.96 1147.31 1808.99 1149.77 1798.94 1145.03L1506.57 1007.11C1500.6 1004.29 1495.98 999.234 1493.73 993.031L1336.12 558.942C1334.35 554.057 1334.14 548.74 1335.53 543.732L1443.64 153.738C1446.15 144.696 1453.51 137.819 1462.7 135.929L1739.17 79.0852C1748.37 77.1955 1757.84 80.6115 1763.71 87.9313L2016.92 403.636C2020.17 407.691 2022.08 412.658 2022.37 417.847L2048.81 878.906C2049.19 885.494 2046.95 891.964 2042.57 896.905L1828.33 1138.99Z",
    fill: "url(#paint1_linear_52_1127)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.0434783,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2000.14 911.124L1774.79 1139.63C1768.25 1146.26 1758.13 1147.8 1749.93 1143.4L1466.98 991.931C1462.09 989.312 1458.43 984.86 1456.81 979.551L1323.17 541.971C1321.89 537.782 1321.95 533.299 1323.35 529.148L1451.13 148.856C1453.63 141.394 1460.1 135.961 1467.89 134.781L1745.29 92.7378C1753.07 91.5583 1760.86 94.8302 1765.47 101.214L2000.2 426.563C2002.76 430.114 2004.15 434.378 2004.17 438.757L2006.19 896.285C2006.22 901.836 2004.04 907.171 2000.14 911.124ZM1777.64 1142.44C1769.86 1150.33 1757.81 1152.16 1748.04 1146.93L1465.09 995.458C1459.26 992.339 1454.91 987.04 1452.98 980.72L1319.34 543.139C1317.82 538.153 1317.89 532.816 1319.55 527.874L1447.34 147.581C1450.32 138.699 1458.02 132.231 1467.29 130.827L1744.69 88.783C1753.95 87.3788 1763.23 91.2739 1768.71 98.8734L2003.44 424.223C2006.49 428.45 2008.14 433.526 2008.17 438.739L2010.19 896.267C2010.22 902.876 2007.63 909.227 2002.99 913.932L1777.64 1142.44Z",
    fill: "url(#paint2_linear_52_1127)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.057971,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1960.14 926.943L1724.5 1141.39C1717.63 1147.63 1707.48 1148.63 1699.53 1143.84L1426.62 979.426C1421.86 976.557 1418.43 971.917 1417.08 966.523L1307.35 526.759C1306.28 522.497 1306.58 518.009 1308.2 513.926L1454.94 144.314C1457.84 137.008 1464.58 131.933 1472.4 131.164L1749.94 103.861C1757.77 103.092 1765.36 106.756 1769.63 113.357L1985.58 447.291C1987.96 450.979 1989.13 455.323 1988.92 459.711L1966.98 912.428C1966.71 917.981 1964.25 923.201 1960.14 926.943ZM1727.19 1144.34C1719.02 1151.78 1706.93 1152.97 1697.46 1147.27L1424.56 982.852C1418.89 979.437 1414.8 973.913 1413.2 967.491L1303.47 527.728C1302.2 522.654 1302.56 517.311 1304.49 512.45L1451.22 142.838C1454.67 134.14 1462.69 128.099 1472.01 127.183L1749.55 99.8804C1758.86 98.9642 1767.91 103.326 1772.99 111.185L1988.94 445.119C1991.78 449.51 1993.17 454.681 1992.91 459.904L1970.97 912.622C1970.65 919.232 1967.72 925.446 1962.83 929.901L1727.19 1144.34Z",
    fill: "url(#paint3_linear_52_1127)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.0724638,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1919.61 941.691L1674.55 1141.62C1667.37 1147.48 1657.21 1147.94 1649.54 1142.77L1387.24 966.036C1382.63 962.924 1379.43 958.107 1378.37 952.642L1292.39 511.986C1291.55 507.661 1292.09 503.181 1293.93 499.178L1458.85 141.179C1462.14 134.049 1469.12 129.346 1476.96 128.987L1753.87 116.325C1761.71 115.966 1769.1 120.011 1773.02 126.812L1969.93 468.265C1972.13 472.083 1973.07 476.496 1972.63 480.879L1927.23 927.542C1926.67 933.082 1923.93 938.171 1919.61 941.691ZM1677.07 1144.72C1668.53 1151.69 1656.44 1152.24 1647.3 1146.08L1385.01 969.353C1379.51 965.649 1375.71 959.913 1374.44 953.408L1288.47 512.752C1287.46 507.604 1288.1 502.269 1290.3 497.505L1455.22 139.505C1459.13 131.017 1467.45 125.418 1476.78 124.991L1753.69 112.329C1763.02 111.902 1771.82 116.718 1776.49 124.814L1973.39 466.267C1976.01 470.811 1977.14 476.065 1976.61 481.284L1931.21 927.947C1930.54 934.541 1927.28 940.6 1922.14 944.79L1677.07 1144.72Z",
    fill: "url(#paint4_linear_52_1127)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.0869565,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1878.64 955.35L1625.01 1140.38C1617.55 1145.82 1607.41 1145.75 1600.03 1140.21L1348.89 951.821C1344.43 948.475 1341.48 943.491 1340.7 937.97L1278.28 497.694C1277.66 493.317 1278.43 488.856 1280.49 484.947L1462.79 139.44C1466.45 132.507 1473.66 128.188 1481.5 128.24L1757.01 130.076C1764.84 130.128 1772 134.543 1775.57 141.524L1953.24 489.429C1955.25 493.366 1955.97 497.836 1955.29 502.205L1887.01 941.61C1886.15 947.12 1883.14 952.064 1878.64 955.35ZM1627.36 1143.61C1618.49 1150.09 1606.42 1150.01 1597.63 1143.41L1346.49 955.021C1341.18 951.037 1337.67 945.105 1336.74 938.531L1274.32 498.256C1273.58 493.045 1274.5 487.735 1276.96 483.08L1459.25 137.574C1463.61 129.32 1472.2 124.178 1481.53 124.241L1757.03 126.076C1766.36 126.138 1774.89 131.393 1779.13 139.705L1956.81 487.609C1959.2 492.296 1960.05 497.619 1959.24 502.819L1890.96 942.224C1889.94 948.784 1886.36 954.669 1880.99 958.582L1627.36 1143.61Z",
    fill: "url(#paint5_linear_52_1127)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.101449,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1837.27 967.908L1575.96 1137.69C1568.24 1142.7 1558.16 1142.11 1551.08 1136.22L1311.59 936.845C1307.3 933.272 1304.6 928.136 1304.11 922.572L1264.96 483.923C1264.57 479.505 1265.58 475.077 1267.86 471.271L1466.68 139.086C1470.7 132.369 1478.12 128.446 1485.94 128.907L1759.28 145.06C1767.1 145.521 1774.01 150.292 1777.21 157.435L1935.52 510.724C1937.33 514.771 1937.82 519.288 1936.91 523.628L1846.38 954.615C1845.23 960.081 1841.95 964.865 1837.27 967.908ZM1578.14 1141.04C1568.95 1147.01 1556.95 1146.3 1548.52 1139.29L1309.03 939.919C1303.92 935.665 1300.71 929.551 1300.12 922.928L1260.98 484.278C1260.51 479.019 1261.72 473.747 1264.43 469.217L1463.25 137.032C1468.03 129.035 1476.87 124.365 1486.17 124.914L1759.52 141.067C1768.82 141.616 1777.05 147.295 1780.86 155.8L1939.17 509.088C1941.33 513.906 1941.91 519.284 1940.82 524.45L1850.29 955.438C1848.92 961.945 1845.02 967.639 1839.45 971.262L1578.14 1141.04Z",
    fill: "url(#paint6_linear_52_1127)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.115942,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1795.57 979.354L1527.48 1133.6C1519.52 1138.17 1509.52 1137.06 1502.77 1130.83L1275.38 921.174C1271.27 917.382 1268.84 912.105 1268.63 906.515L1252.43 470.71C1252.26 466.264 1253.51 461.88 1256 458.191L1470.45 140.099C1474.81 133.618 1482.42 130.1 1490.19 130.969L1760.64 161.217C1768.41 162.086 1775.06 167.198 1777.89 174.485L1916.76 532.093C1918.37 536.241 1918.62 540.793 1917.48 545.093L1805.39 966.549C1803.95 971.955 1800.42 976.564 1795.57 979.354ZM1529.47 1137.07C1520 1142.51 1508.09 1141.18 1500.06 1133.78L1272.67 924.114C1267.78 919.6 1264.88 913.319 1264.64 906.664L1248.43 470.859C1248.23 465.565 1249.72 460.347 1252.68 455.955L1467.13 137.863C1472.33 130.147 1481.39 125.959 1490.64 126.993L1761.09 157.242C1770.34 158.276 1778.25 164.362 1781.61 173.037L1920.49 530.645C1922.41 535.583 1922.71 541.002 1921.34 546.121L1809.26 967.577C1807.54 974.013 1803.34 979.5 1797.56 982.821L1529.47 1137.07Z",
    fill: "url(#paint7_linear_52_1127)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.130435,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1753.6 989.68L1479.64 1128.15C1471.47 1132.28 1461.57 1130.64 1455.17 1124.1L1240.3 904.872C1236.38 900.87 1234.22 895.467 1234.3 889.865L1240.62 458.092C1240.69 453.628 1242.17 449.301 1244.87 445.739L1474.02 142.459C1478.72 136.231 1486.49 133.127 1494.19 134.399L1761.03 178.487C1768.73 179.759 1775.09 185.198 1777.55 192.608L1896.96 553.48C1898.37 557.718 1898.38 562.293 1897.01 566.54L1764.11 977.401C1762.39 982.732 1758.6 987.153 1753.6 989.68ZM1481.44 1131.72C1471.72 1136.63 1459.93 1134.68 1452.31 1126.9L1237.44 907.671C1232.77 902.908 1230.2 896.476 1230.3 889.806L1236.62 458.033C1236.7 452.719 1238.47 447.568 1241.67 443.328L1470.82 140.048C1476.43 132.633 1485.68 128.938 1494.85 130.453L1761.68 174.54C1770.85 176.055 1778.42 182.53 1781.34 191.352L1900.76 552.223C1902.43 557.269 1902.45 562.715 1900.81 567.771L1767.92 978.632C1765.86 984.978 1761.36 990.241 1755.41 993.25L1481.44 1131.72Z",
    fill: "url(#paint8_linear_52_1127)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.144928,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1711.43 998.884L1432.5 1121.39C1424.15 1125.06 1414.38 1122.91 1408.33 1116.08L1206.36 888.007C1202.64 883.805 1200.76 878.29 1201.13 872.69L1229.52 446.102C1229.82 441.632 1231.54 437.375 1234.43 433.952L1477.32 146.14C1482.35 140.184 1490.26 137.501 1497.87 139.173L1760.39 196.804C1768.01 198.475 1774.07 204.225 1776.14 211.739L1876.14 574.827C1877.33 579.146 1877.11 583.731 1875.5 587.914L1722.6 987.168C1720.59 992.408 1716.57 996.628 1711.43 998.884ZM1434.11 1125.05C1424.16 1129.42 1412.54 1126.86 1405.34 1118.73L1203.37 890.659C1198.94 885.657 1196.7 879.091 1197.14 872.424L1225.53 445.836C1225.88 440.515 1227.93 435.447 1231.37 431.372L1474.26 143.56C1480.25 136.469 1489.67 133.276 1498.73 135.266L1761.25 192.897C1770.31 194.886 1777.53 201.732 1779.99 210.677L1880 573.765C1881.41 578.906 1881.15 584.365 1879.24 589.345L1726.33 988.598C1723.94 994.837 1719.16 999.86 1713.04 1002.55L1434.11 1125.05Z",
    fill: "url(#paint9_linear_52_1127)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.15942,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1669.11 1006.97L1386.13 1113.37C1377.62 1116.57 1368.01 1113.93 1362.33 1106.82L1173.59 870.648C1170.09 866.257 1168.48 860.642 1169.15 855.061L1219.08 434.772C1219.61 430.309 1221.56 426.134 1224.64 422.86L1480.29 151.116C1485.62 145.447 1493.65 143.193 1501.16 145.257L1758.68 216.103C1766.18 218.167 1771.93 224.211 1773.61 231.809L1854.3 596.081C1855.27 600.469 1854.81 605.054 1852.98 609.16L1680.91 995.848C1678.62 1000.98 1674.38 1004.99 1669.11 1006.97ZM1387.54 1117.11C1377.4 1120.92 1365.97 1117.78 1359.21 1109.32L1170.47 873.145C1166.29 867.918 1164.39 861.234 1165.17 854.589L1215.11 434.301C1215.74 428.987 1218.06 424.017 1221.72 420.12L1477.38 148.375C1483.72 141.627 1493.28 138.943 1502.22 141.401L1759.74 212.246C1768.67 214.703 1775.51 221.899 1777.52 230.944L1858.2 595.216C1859.36 600.44 1858.81 605.898 1856.63 610.786L1684.56 997.474C1681.84 1003.59 1676.79 1008.36 1670.52 1010.71L1387.54 1117.11Z",
    fill: "url(#paint10_linear_52_1127)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.173913,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1626.71 1013.93L1340.59 1104.15C1331.95 1106.88 1322.53 1103.75 1317.23 1096.39L1142.02 852.863C1138.73 848.293 1137.41 842.594 1138.36 837.045L1209.26 424.132C1210.02 419.687 1212.2 415.605 1215.46 412.492L1482.86 157.352C1488.48 151.988 1496.61 150.167 1503.98 152.617L1755.85 236.313C1763.22 238.763 1768.64 245.085 1769.93 252.746L1831.45 617.185C1832.2 621.632 1831.49 626.203 1829.45 630.221L1639.11 1003.44C1636.55 1008.46 1632.08 1012.24 1626.71 1013.93ZM1341.8 1107.96C1331.5 1111.21 1320.29 1107.48 1313.99 1098.72L1138.77 855.199C1134.85 849.759 1133.29 842.974 1134.42 836.368L1205.32 423.455C1206.22 418.163 1208.81 413.304 1212.7 409.598L1480.1 154.458C1486.79 148.073 1496.46 145.904 1505.24 148.821L1757.11 232.517C1765.89 235.434 1772.34 242.96 1773.88 252.081L1835.39 616.519C1836.28 621.813 1835.45 627.255 1833.01 632.038L1642.67 1005.26C1639.62 1011.23 1634.31 1015.73 1627.92 1017.74L1341.8 1107.96Z",
    fill: "url(#paint11_linear_52_1127)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.188406,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1584.29 1019.78L1295.95 1093.78C1287.19 1096.03 1277.98 1092.42 1273.08 1084.83L1111.64 834.723C1108.58 829.985 1107.55 824.216 1108.79 818.714L1200.02 414.208C1201.01 409.793 1203.41 405.817 1206.85 402.874L1484.96 164.816C1490.86 159.772 1499.05 158.387 1506.28 161.215L1751.85 257.366C1759.08 260.194 1764.15 266.774 1765.05 274.48L1807.6 638.086C1808.13 642.581 1807.19 647.127 1804.92 651.044L1597.25 1009.96C1594.42 1014.84 1589.75 1018.38 1584.29 1019.78ZM1296.94 1097.66C1286.52 1100.33 1275.56 1096.04 1269.72 1087L1108.27 836.892C1104.63 831.252 1103.41 824.383 1104.89 817.834L1196.12 413.328C1197.3 408.072 1200.15 403.339 1204.25 399.835L1482.36 161.777C1489.38 155.772 1499.13 154.124 1507.73 157.491L1753.31 253.641C1761.91 257.008 1767.95 264.842 1769.03 274.015L1811.58 637.621C1812.2 642.973 1811.08 648.384 1808.38 653.047L1600.71 1011.96C1597.35 1017.77 1591.79 1021.99 1585.28 1023.65L1296.94 1097.66Z",
    fill: "url(#paint12_linear_52_1127)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.202899,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1541.9 1024.53L1252.24 1082.33C1243.41 1084.1 1234.43 1080.03 1229.93 1072.22L1082.47 816.296C1079.65 811.402 1078.92 805.577 1080.44 800.138L1191.32 405.025C1192.54 400.651 1195.16 396.794 1198.76 394.03L1486.54 173.469C1492.69 168.757 1500.93 167.812 1507.99 171.009L1746.67 279.187C1753.72 282.384 1758.44 289.205 1758.95 296.934L1782.79 658.732C1783.09 663.264 1781.91 667.771 1779.43 671.577L1555.39 1015.4C1552.3 1020.13 1547.44 1023.42 1541.9 1024.53ZM1253.02 1086.26C1242.51 1088.36 1231.82 1083.51 1226.47 1074.22L1079 818.293C1075.64 812.467 1074.78 805.533 1076.59 799.058L1187.47 403.944C1188.93 398.737 1192.04 394.145 1196.33 390.856L1484.11 170.294C1491.43 164.685 1501.24 163.559 1509.64 167.366L1748.32 275.544C1756.72 279.35 1762.34 287.47 1762.94 296.671L1786.78 658.469C1787.13 663.865 1785.73 669.23 1782.78 673.761L1558.74 1017.58C1555.07 1023.22 1549.28 1027.14 1542.69 1028.45L1253.02 1086.26Z",
    fill: "url(#paint13_linear_52_1127)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.217391,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1499.61 1028.19L1209.53 1069.86C1200.64 1071.14 1191.92 1066.63 1187.84 1058.63L1054.52 797.654C1051.94 792.615 1051.51 786.75 1053.32 781.388L1183.11 396.604C1184.57 392.285 1187.39 388.556 1191.15 385.983L1487.54 183.268C1493.92 178.903 1502.18 178.398 1509.05 181.955L1740.25 301.704C1747.12 305.26 1751.47 312.302 1751.59 320.034L1757.02 679.071C1757.09 683.629 1755.67 688.086 1752.98 691.768L1513.58 1019.78C1510.25 1024.35 1505.21 1027.38 1499.61 1028.19ZM1210.1 1073.82C1199.52 1075.34 1189.14 1069.97 1184.28 1060.45L1050.95 799.474C1047.89 793.475 1047.37 786.493 1049.53 780.11L1179.32 395.326C1181.05 390.183 1184.41 385.745 1188.89 382.681L1485.28 179.967C1492.88 174.77 1502.72 174.169 1510.89 178.403L1742.09 298.152C1750.26 302.386 1755.45 310.769 1755.59 319.973L1761.02 679.01C1761.1 684.437 1759.41 689.743 1756.21 694.127L1516.82 1022.14C1512.84 1027.58 1506.85 1031.19 1500.18 1032.15L1210.1 1073.82Z",
    fill: "url(#paint14_linear_52_1127)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.231884,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1457.47 1030.77L1167.85 1056.44C1158.94 1057.23 1150.5 1052.28 1146.84 1044.12L1027.78 778.864C1025.46 773.693 1025.33 767.803 1027.42 762.533L1175.35 388.966C1177.04 384.712 1180.07 381.125 1183.98 378.75L1487.89 194.171C1494.49 190.164 1502.75 190.1 1509.41 194.004L1732.58 324.841C1739.24 328.745 1743.22 335.988 1742.95 343.703L1730.32 699.054C1730.16 703.626 1728.51 708.021 1725.62 711.569L1471.89 1023.12C1468.32 1027.51 1463.11 1030.27 1457.47 1030.77ZM1168.21 1060.42C1157.59 1061.36 1147.55 1055.47 1143.19 1045.76L1024.13 780.502C1021.37 774.346 1021.21 767.334 1023.7 761.06L1171.63 387.494C1173.64 382.429 1177.24 378.158 1181.9 375.331L1485.82 190.752C1493.67 185.982 1503.51 185.905 1511.44 190.553L1734.61 321.39C1742.53 326.038 1747.27 334.661 1746.95 343.845L1734.32 699.196C1734.13 704.639 1732.16 709.871 1728.72 714.095L1475 1025.64C1470.74 1030.87 1464.54 1034.16 1457.82 1034.76L1168.21 1060.42Z",
    fill: "url(#paint15_linear_52_1127)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.246377,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1415.53 1032.3L1127.26 1042.12C1118.35 1042.43 1110.21 1037.07 1106.98 1028.76L1002.27 759.998C1000.2 754.707 1000.37 748.807 1002.73 743.643L1168 382.129C1169.91 377.952 1173.14 374.516 1177.19 372.348L1487.55 206.131C1494.35 202.492 1502.59 202.867 1509.02 207.107L1723.64 348.523C1730.07 352.763 1733.67 360.187 1733.01 367.865L1702.72 718.632C1702.33 723.208 1700.44 727.528 1697.36 730.931L1430.37 1025.42C1426.56 1029.63 1421.2 1032.11 1415.53 1032.3ZM1127.39 1046.12C1116.78 1046.48 1107.1 1040.1 1103.25 1030.21L998.539 761.45C996.085 755.151 996.286 748.127 999.096 741.98L1164.37 380.466C1166.64 375.493 1170.48 371.403 1175.3 368.821L1485.67 202.604C1493.75 198.273 1503.56 198.719 1511.22 203.767L1725.84 345.183C1733.5 350.23 1737.78 359.069 1736.99 368.209L1706.71 718.977C1706.24 724.424 1703.99 729.567 1700.32 733.618L1433.33 1028.11C1428.79 1033.12 1422.42 1036.07 1415.66 1036.3L1127.39 1046.12Z",
    fill: "url(#paint16_linear_52_1127)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.26087,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1373.85 1032.8L1087.78 1026.99C1078.9 1026.81 1071.09 1021.05 1068.28 1012.62L977.96 741.122C976.165 735.725 976.635 729.83 979.264 724.786L1161.01 376.105C1163.15 372.017 1166.56 368.743 1170.74 366.79L1486.47 219.097C1493.44 215.838 1501.64 216.649 1507.83 221.212L1713.4 372.672C1719.6 377.235 1722.8 384.82 1721.75 392.441L1674.25 737.761C1673.62 742.328 1671.51 746.562 1668.23 749.808L1389.07 1026.72C1385.03 1030.72 1379.54 1032.92 1373.85 1032.8ZM1087.7 1030.99C1077.12 1030.77 1067.83 1023.92 1064.49 1013.88L974.165 742.384C972.027 735.959 972.587 728.942 975.717 722.937L1157.47 374.256C1160 369.389 1164.07 365.492 1169.04 363.167L1484.78 215.474C1493.08 211.593 1502.83 212.559 1510.2 217.992L1715.77 369.452C1723.15 374.884 1726.96 383.913 1725.71 392.986L1678.21 738.306C1677.46 743.743 1674.95 748.783 1671.05 752.648L1391.88 1029.56C1387.08 1034.33 1380.54 1036.94 1373.77 1036.8L1087.7 1030.99Z",
    fill: "url(#paint17_linear_52_1127)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.275362,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1332.49 1032.29L1049.46 1011.1C1040.63 1010.44 1033.16 1004.31 1030.79 995.781L954.855 722.305C953.33 716.814 954.102 710.94 956.994 706.03L1154.34 370.907C1156.69 366.919 1160.29 363.819 1164.58 362.088L1484.61 233.019C1491.73 230.147 1499.85 231.391 1505.79 236.263L1701.86 397.213C1707.79 402.085 1710.59 409.808 1709.16 417.353L1644.93 756.394C1644.07 760.941 1641.73 765.076 1638.28 768.157L1348.03 1027.02C1343.78 1030.82 1338.17 1032.72 1332.49 1032.29ZM1049.16 1015.09C1038.64 1014.31 1029.76 1007.01 1026.93 996.851L951.001 723.375C949.186 716.839 950.105 709.846 953.547 704.001L1150.89 368.878C1153.69 364.13 1157.98 360.439 1163.09 358.378L1483.11 229.31C1491.59 225.89 1501.26 227.371 1508.32 233.171L1704.39 394.121C1711.46 399.921 1714.8 409.116 1713.09 418.098L1648.86 757.138C1647.83 762.552 1645.05 767.475 1640.94 771.142L1350.69 1030.01C1345.63 1034.52 1338.95 1036.79 1332.19 1036.28L1049.16 1015.09Z",
    fill: "url(#paint18_linear_52_1127)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.289855,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1291.48 1030.8L1012.31 994.543C1003.56 993.406 996.454 986.921 994.524 978.312L932.937 703.613C931.688 698.043 932.761 692.205 935.908 687.442L1147.94 366.546C1150.5 362.669 1154.27 359.752 1158.67 358.25L1481.91 247.843C1489.16 245.366 1497.19 247.037 1502.85 252.204L1688.99 422.067C1694.66 427.234 1697.05 435.075 1695.25 442.525L1614.8 774.489C1613.71 779.005 1611.15 783.03 1607.52 785.935L1307.32 1026.37C1302.86 1029.94 1297.14 1031.54 1291.48 1030.8ZM1011.8 998.509C1001.38 997.156 992.919 989.436 990.621 979.187L929.034 704.488C927.547 697.857 928.824 690.907 932.57 685.237L1144.6 364.341C1147.65 359.726 1152.14 356.252 1157.38 354.464L1480.61 244.058C1489.25 241.109 1498.81 243.098 1505.55 249.249L1691.69 419.112C1698.43 425.263 1701.28 434.598 1699.13 443.467L1618.69 775.431C1617.39 780.807 1614.34 785.599 1610.02 789.057L1309.82 1029.49C1304.51 1033.74 1297.71 1035.64 1290.97 1034.77L1011.8 998.509Z",
    fill: "url(#paint19_linear_52_1127)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.304348,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1250.89 1028.36L976.37 977.377C967.727 975.772 960.998 968.953 959.508 960.289L912.189 685.112C911.22 679.477 912.591 673.689 915.986 669.087L1141.76 363.027C1144.53 359.273 1148.47 356.548 1152.96 355.282L1478.34 263.515C1485.7 261.438 1493.61 263.53 1498.99 268.976L1674.81 447.158C1680.18 452.604 1682.17 460.542 1680 467.877L1583.9 792.007C1582.58 796.48 1579.8 800.384 1576.01 803.102L1266.97 1024.78C1262.32 1028.11 1256.51 1029.4 1250.89 1028.36ZM975.64 981.31C965.35 979.399 957.34 971.281 955.566 960.967L908.247 685.79C907.093 679.081 908.726 672.191 912.767 666.713L1138.54 360.653C1141.83 356.184 1146.53 352.939 1151.87 351.432L1477.25 259.665C1486.02 257.192 1495.44 259.683 1501.83 266.167L1677.66 444.349C1684.05 450.832 1686.42 460.282 1683.83 469.014L1587.74 793.144C1586.16 798.469 1582.85 803.116 1578.34 806.353L1269.3 1028.03C1263.77 1031.99 1256.85 1033.53 1250.16 1032.29L975.64 981.31Z",
    fill: "url(#paint20_linear_52_1127)"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.318841,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1210.76 1025L941.655 959.68C933.144 957.614 926.808 950.483 925.759 941.788L892.59 666.867C891.904 661.179 893.572 655.458 897.206 651.029L1135.75 360.356C1138.72 356.735 1142.82 354.212 1147.39 353.187L1473.86 279.976C1481.31 278.305 1489.08 280.811 1494.16 286.52L1659.3 472.41C1664.38 478.119 1665.95 486.132 1663.41 493.334L1552.26 808.91C1550.71 813.328 1547.72 817.099 1543.77 819.623L1227.03 1022.28C1222.2 1025.37 1216.32 1026.35 1210.76 1025ZM940.711 963.567C930.579 961.108 923.037 952.619 921.788 942.267L888.619 667.346C887.802 660.575 889.787 653.764 894.114 648.492L1132.66 357.818C1136.2 353.508 1141.08 350.504 1146.52 349.284L1472.99 276.073C1481.86 274.084 1491.11 277.067 1497.15 283.863L1662.29 469.754C1668.33 476.55 1670.2 486.088 1667.18 494.663L1556.03 810.239C1554.18 815.498 1550.62 819.987 1545.93 822.992L1229.18 1025.65C1223.44 1029.32 1216.44 1030.49 1209.81 1028.88L940.711 963.567Z",
    fill: "url(#paint21_linear_52_1127)"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.333333,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1171.12 1020.75L908.182 941.526C899.827 939.009 893.9 931.588 893.291 922.885L874.117 648.938C873.717 643.213 875.677 637.572 879.542 633.33L1129.88 358.534C1133.05 355.057 1137.29 352.744 1141.93 351.966L1468.45 297.169C1475.96 295.907 1483.57 298.817 1488.33 304.772L1642.48 497.747C1647.24 503.702 1648.39 511.767 1645.5 518.819L1519.92 825.161C1518.14 829.513 1514.95 833.14 1510.86 835.461L1187.54 1018.9C1182.55 1021.74 1176.62 1022.4 1171.12 1020.75ZM907.028 945.355C897.082 942.359 890.026 933.525 889.301 923.164L870.127 649.217C869.65 642.401 871.984 635.687 876.585 630.636L1126.92 355.84C1130.7 351.701 1135.75 348.948 1141.27 348.021L1467.78 293.224C1476.73 291.722 1485.79 295.186 1491.45 302.276L1645.61 495.251C1651.27 502.34 1652.65 511.941 1649.2 520.336L1523.62 826.678C1521.5 831.859 1517.7 836.177 1512.83 838.94L1189.52 1022.38C1183.58 1025.76 1176.51 1026.55 1169.97 1024.58L907.028 945.355Z",
    fill: "url(#paint22_linear_52_1127)"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.347826,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1132.03 1015.65L875.961 922.988C867.789 920.03 862.282 912.344 862.111 903.655L856.742 631.387C856.628 625.638 858.877 620.094 862.964 616.049L1124.1 357.561C1127.45 354.239 1131.83 352.144 1136.52 351.617L1462.06 315.033C1469.62 314.184 1477.05 317.488 1481.48 323.672L1624.35 523.094C1628.78 529.277 1629.52 537.373 1626.28 544.257L1486.93 840.728C1484.92 845.002 1481.53 848.474 1477.3 850.583L1148.56 1014.69C1143.41 1017.26 1137.44 1017.61 1132.03 1015.65ZM874.6 926.749C864.871 923.228 858.316 914.078 858.112 903.734L852.742 631.466C852.607 624.622 855.285 618.022 860.15 613.206L1121.28 354.718C1125.28 350.763 1130.49 348.27 1136.08 347.642L1461.62 311.058C1470.62 310.047 1479.46 313.981 1484.73 321.342L1627.6 520.764C1632.87 528.126 1633.75 537.763 1629.9 545.959L1490.55 842.429C1488.16 847.518 1484.12 851.651 1479.09 854.162L1150.34 1018.27C1144.22 1021.33 1137.11 1021.74 1130.67 1019.41L874.6 926.749Z",
    fill: "url(#paint23_linear_52_1127)"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.362319,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1093.52 1009.74L845.002 904.14C837.034 900.754 831.961 892.827 832.224 884.174L840.433 614.272C840.608 608.514 843.141 603.08 847.439 599.244L1118.35 357.434C1121.89 354.276 1126.39 352.408 1131.13 352.136L1454.69 333.509C1462.27 333.073 1469.49 336.761 1473.58 343.154L1604.92 548.377C1609.01 554.77 1609.33 562.875 1605.76 569.574L1453.32 855.578C1451.09 859.764 1447.51 863.071 1443.16 864.961L1110.1 1009.67C1104.82 1011.97 1098.83 1011.99 1093.52 1009.74ZM843.438 907.821C833.953 903.791 827.913 894.353 828.226 884.052L836.435 614.151C836.643 607.295 839.659 600.827 844.776 596.259L1115.69 354.45C1119.9 350.69 1125.26 348.467 1130.9 348.142L1454.46 329.516C1463.48 328.996 1472.08 333.386 1476.95 340.998L1608.29 546.22C1613.16 553.832 1613.54 563.48 1609.29 571.456L1456.85 857.46C1454.19 862.442 1449.93 866.379 1444.75 868.63L1111.7 1013.34C1105.41 1016.08 1098.27 1016.1 1091.96 1013.42L843.438 907.821Z",
    fill: "url(#paint24_linear_52_1127)"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.376812,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1055.63 1003.06L815.305 885.056C807.566 881.256 802.936 873.112 803.629 864.517L825.156 597.649C825.62 591.896 828.432 586.587 832.931 582.971L1112.6 358.148C1116.31 355.163 1120.93 353.53 1125.69 353.515L1446.3 352.535C1453.87 352.512 1460.87 356.571 1464.62 363.156L1584.21 573.523C1587.95 580.109 1587.86 588.2 1583.97 594.698L1419.14 869.685C1416.69 873.771 1412.92 876.903 1408.46 878.566L1072.22 1003.89C1066.81 1005.9 1060.81 1005.6 1055.63 1003.06ZM813.542 888.647C804.329 884.123 798.817 874.427 799.642 864.196L821.169 597.328C821.722 590.478 825.069 584.158 830.425 579.853L1110.09 355.03C1114.51 351.477 1120.01 349.532 1125.68 349.515L1446.28 348.535C1455.3 348.507 1463.64 353.339 1468.09 361.179L1587.69 571.546C1592.14 579.386 1592.03 589.019 1587.4 596.754L1422.57 871.742C1419.65 876.606 1415.17 880.334 1409.86 882.314L1073.62 1007.64C1067.18 1010.04 1060.04 1009.68 1053.87 1006.65L813.542 888.647Z",
    fill: "url(#paint25_linear_52_1127)"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.391304,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1018.4 995.649L786.872 865.81C779.383 861.61 775.205 853.273 776.323 844.76L810.877 581.573C811.63 575.839 814.714 570.669 819.402 567.283L1106.8 359.695C1110.68 356.893 1115.4 355.5 1120.18 355.746L1436.87 372.049C1444.42 372.438 1451.18 376.854 1454.57 383.612L1562.24 598.462C1565.63 605.22 1565.12 613.277 1560.91 619.558L1384.43 883.023C1381.77 886.998 1377.83 889.944 1373.26 891.375L1034.95 997.372C1029.43 999.101 1023.44 998.478 1018.4 995.649ZM784.916 869.299C776 864.299 771.026 854.374 772.357 844.239L806.911 581.052C807.807 574.226 811.479 568.071 817.06 564.04L1104.46 356.452C1109.08 353.117 1114.7 351.459 1120.38 351.752L1437.08 368.054C1446.07 368.517 1454.11 373.775 1458.14 381.82L1565.82 596.67C1569.85 604.715 1569.25 614.307 1564.24 621.784L1387.75 885.249C1384.58 889.981 1379.89 893.489 1374.46 895.192L1036.14 1001.19C1029.57 1003.25 1022.44 1002.51 1016.44 999.138L784.916 869.299Z",
    fill: "url(#paint26_linear_52_1127)"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.405797,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M981.844 987.551L759.697 846.473C752.479 841.889 748.761 833.386 750.296 824.975L797.554 566.094C798.594 560.393 801.944 555.376 806.81 552.23L1100.91 362.065C1104.95 359.456 1109.76 358.309 1114.54 358.818L1426.4 391.989C1433.9 392.787 1440.4 397.546 1443.42 404.458L1539.04 623.124C1542.06 630.036 1541.14 638.037 1536.64 644.086L1349.24 895.568C1346.37 899.421 1342.26 902.173 1337.61 903.365L998.307 990.169C992.693 991.605 986.736 990.658 981.844 987.551ZM757.552 849.85C748.959 844.392 744.533 834.27 746.361 824.256L793.619 565.375C794.857 558.589 798.845 552.617 804.638 548.871L1098.74 358.706C1103.55 355.6 1109.27 354.235 1114.96 354.84L1426.83 388.011C1435.76 388.961 1443.49 394.627 1447.09 402.855L1542.7 621.522C1546.3 629.75 1545.21 639.275 1539.84 646.476L1352.45 897.958C1349.03 902.545 1344.14 905.822 1338.6 907.24L999.298 994.044C992.615 995.754 985.523 994.626 979.7 990.928L757.552 849.85Z",
    fill: "url(#paint27_linear_52_1127)"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.42029,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M946.006 978.811L733.77 827.117C726.843 822.166 723.591 813.523 725.536 805.234L785.145 551.261C786.472 545.609 790.079 540.758 795.111 537.861L1094.89 365.246C1099.08 362.837 1103.96 361.944 1108.73 362.715L1414.88 412.293C1422.31 413.496 1428.52 418.583 1431.17 425.628L1514.63 647.444C1517.28 654.488 1515.96 662.412 1511.16 668.215L1313.62 907.3C1310.55 911.021 1306.28 913.57 1301.55 914.516L962.333 982.319C956.64 983.457 950.73 982.187 946.006 978.811ZM731.444 830.371C723.198 824.477 719.326 814.188 721.642 804.32L781.251 550.347C782.83 543.618 787.125 537.843 793.115 534.394L1092.9 361.78C1097.88 358.912 1103.69 357.848 1109.37 358.767L1415.52 408.344C1424.36 409.776 1431.76 415.833 1434.92 424.219L1518.37 646.035C1521.53 654.422 1519.95 663.855 1514.25 670.763L1316.71 909.847C1313.05 914.278 1307.97 917.312 1302.33 918.439L963.117 986.241C956.34 987.596 949.303 986.084 943.68 982.065L731.444 830.371Z",
    fill: "url(#paint28_linear_52_1127)"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.434783,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M910.908 969.473L709.077 807.812C702.461 802.512 699.679 793.754 702.026 785.608L773.606 537.12C775.216 531.53 779.073 526.859 784.257 524.219L1088.7 369.225C1093.02 367.024 1097.97 366.388 1102.71 367.423L1402.29 432.897C1409.62 434.501 1415.54 439.9 1417.82 447.057L1489.05 671.355C1491.32 678.512 1489.6 686.339 1484.53 691.881L1277.62 918.201C1274.34 921.781 1269.93 924.118 1265.13 924.814L927.051 973.865C921.294 974.7 915.448 973.11 910.908 969.473ZM706.576 810.934C698.7 804.625 695.389 794.199 698.182 784.501L769.762 536.013C771.679 529.358 776.271 523.797 782.443 520.655L1086.88 365.66C1092.03 363.04 1097.92 362.283 1103.56 363.515L1403.14 428.99C1411.87 430.898 1418.92 437.326 1421.63 445.846L1492.86 670.144C1495.56 678.665 1493.51 687.982 1487.48 694.58L1280.57 920.9C1276.67 925.162 1271.42 927.943 1265.71 928.773L927.626 977.823C920.772 978.818 913.813 976.924 908.407 972.595L706.576 810.934Z",
    fill: "url(#paint29_linear_52_1127)"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.449275,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M876.573 959.584L685.602 788.626C679.314 782.997 677.007 774.151 679.745 766.168L762.889 523.715C764.78 518.201 768.878 513.721 774.202 511.348L1082.28 373.983C1086.73 371.999 1091.74 371.624 1096.43 372.923L1388.63 453.742C1395.85 455.739 1401.46 461.432 1403.35 468.682L1462.32 694.795C1464.22 702.045 1462.1 709.753 1456.77 715.023L1241.28 928.258C1237.81 931.686 1233.26 933.802 1228.41 934.244L892.485 964.851C886.68 965.38 880.916 963.472 876.573 959.584ZM682.934 791.607C675.449 784.905 672.702 774.374 675.961 764.87L759.106 522.418C761.357 515.853 766.235 510.52 772.573 507.694L1080.65 370.33C1085.95 367.968 1091.91 367.521 1097.5 369.068L1389.69 449.886C1398.29 452.264 1404.97 459.042 1407.22 467.672L1466.19 693.786C1468.45 702.416 1465.93 711.593 1459.59 717.866L1244.09 931.101C1239.97 935.182 1234.55 937.701 1228.77 938.228L892.848 968.834C885.937 969.464 879.076 967.193 873.905 962.564L682.934 791.607Z",
    fill: "url(#paint30_linear_52_1127)"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.463768,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M843.023 949.19L663.325 769.627C657.382 763.689 655.55 754.78 658.668 746.979L752.947 511.085C755.115 505.662 759.444 501.386 764.894 499.285L1075.62 379.504C1080.19 377.743 1085.23 377.633 1089.87 379.195L1373.9 474.764C1380.99 477.147 1386.27 483.117 1387.77 490.438L1434.5 717.705C1436.01 725.027 1433.51 732.596 1427.94 737.582L1204.65 937.458C1201 940.724 1196.33 942.612 1191.43 942.796L858.656 955.321C852.82 955.54 847.155 953.319 843.023 949.19ZM660.497 772.457C653.423 765.388 651.242 754.782 654.954 745.495L749.233 509.601C751.814 503.144 756.967 498.053 763.455 495.552L1074.18 375.772C1079.62 373.675 1085.62 373.545 1091.14 375.404L1375.18 470.972C1383.61 473.81 1389.9 480.916 1391.69 489.632L1438.42 716.9C1440.21 725.616 1437.24 734.627 1430.61 740.562L1207.32 940.438C1202.97 944.326 1197.41 946.574 1191.58 946.793L858.807 959.318C851.858 959.579 845.114 956.935 840.196 952.02L660.497 772.457Z",
    fill: "url(#paint31_linear_52_1127)"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.478261,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M810.275 938.341L642.219 750.88C636.637 744.653 635.282 735.708 638.768 728.107L743.728 499.268C746.168 493.948 750.718 489.887 756.28 488.066L1068.66 385.766C1073.34 384.235 1078.4 384.394 1082.97 386.216L1358.11 495.902C1365.04 498.664 1369.98 504.89 1371.1 512.263L1405.62 740.028C1406.74 747.4 1403.86 754.812 1398.07 759.501L1167.78 945.791C1163.96 948.886 1159.17 950.539 1154.25 950.462L825.583 945.32C819.73 945.229 814.182 942.699 810.275 938.341ZM639.241 753.55C632.596 746.137 630.982 735.488 635.132 726.44L740.092 497.6C742.997 491.267 748.413 486.433 755.035 484.264L1067.41 381.965C1072.98 380.142 1079.01 380.331 1084.45 382.5L1359.6 492.187C1367.84 495.474 1373.72 502.887 1375.06 511.663L1409.58 739.428C1410.91 748.205 1407.48 757.028 1400.58 762.611L1170.3 948.901C1165.74 952.585 1160.04 954.553 1154.18 954.461L825.52 949.32C818.553 949.211 811.947 946.199 807.296 941.011L639.241 753.55Z",
    fill: "url(#paint32_linear_52_1127)"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.492754,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M778.343 927.083L622.258 732.447C617.051 725.954 616.17 716.999 620.012 709.616L735.178 488.296C737.886 483.093 742.646 479.26 748.306 477.723L1061.37 392.748C1066.15 391.453 1071.22 391.883 1075.71 393.963L1341.27 517.099C1348.02 520.228 1352.61 526.692 1353.33 534.095L1375.73 761.708C1376.45 769.111 1373.21 776.346 1367.2 780.729L1130.73 953.252C1126.73 956.166 1121.84 957.578 1116.9 957.237L793.28 934.895C787.428 934.491 782.012 931.659 778.343 927.083ZM619.138 734.95C612.939 727.22 611.89 716.559 616.464 707.769L731.63 486.45C734.853 480.256 740.52 475.692 747.258 473.863L1060.33 388.888C1066.01 387.346 1072.05 387.858 1077.39 390.334L1342.95 513.47C1350.99 517.195 1356.45 524.891 1357.32 533.703L1379.71 761.317C1380.57 770.129 1376.71 778.742 1369.56 783.961L1133.09 956.483C1128.33 959.953 1122.5 961.633 1116.63 961.227L793.004 938.886C786.038 938.405 779.591 935.033 775.223 929.585L619.138 734.95Z",
    fill: "url(#paint33_linear_52_1127)"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.507246,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M747.241 915.466L603.41 714.39C598.591 707.653 598.182 698.713 602.366 691.565L727.245 478.201C730.214 473.129 735.172 469.532 740.916 468.286L1053.73 400.426C1058.58 399.372 1063.66 400.075 1068.04 402.41L1323.38 538.294C1329.93 541.779 1334.15 548.461 1334.49 555.873L1344.86 782.696C1345.2 790.107 1341.61 797.148 1335.4 801.216L1093.54 959.837C1089.38 962.562 1084.39 963.725 1079.46 963.119L761.76 924.092C755.926 923.375 750.66 920.246 747.241 915.466ZM600.157 716.717C594.42 708.697 593.933 698.054 598.914 689.544L723.792 476.181C727.327 470.142 733.23 465.861 740.068 464.377L1052.88 396.517C1058.66 395.262 1064.7 396.099 1069.92 398.879L1325.26 534.762C1333.06 538.912 1338.08 546.867 1338.49 555.69L1348.86 782.514C1349.26 791.336 1344.98 799.717 1337.6 804.561L1095.73 963.181C1090.78 966.426 1084.84 967.811 1078.97 967.09L761.272 928.062C754.328 927.209 748.058 923.484 743.987 917.793L600.157 716.717Z",
    fill: "url(#paint34_linear_52_1127)"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.521739,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M716.977 903.538L585.64 696.767C581.221 689.81 581.281 680.91 585.792 674.013L719.872 469.01C723.096 464.081 728.242 460.732 734.055 459.78L1045.68 408.774C1050.61 407.967 1055.67 408.944 1059.94 411.529L1304.46 559.429C1310.79 563.259 1314.64 570.138 1314.59 577.538L1313.09 802.943C1313.04 810.343 1309.1 817.17 1302.72 820.915L1056.25 965.545C1051.94 968.073 1046.88 968.983 1041.96 968.11L731.036 912.956C725.236 911.927 720.135 908.51 716.977 903.538ZM582.264 698.911C577.003 690.629 577.074 680.035 582.444 671.823L716.524 466.821C720.363 460.952 726.489 456.966 733.409 455.833L1045.04 404.826C1050.91 403.865 1056.93 405.029 1062.01 408.107L1306.53 556.007C1314.06 560.566 1318.65 568.756 1318.59 577.565L1317.09 802.97C1317.03 811.779 1312.34 819.907 1304.74 824.365L1058.28 968.994C1053.15 972.004 1047.11 973.087 1041.26 972.048L730.337 916.894C723.433 915.669 717.36 911.601 713.601 905.682L582.264 698.911Z",
    fill: "url(#paint35_linear_52_1127)"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.536232,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M687.558 891.347L568.911 679.633C564.902 672.479 565.424 663.646 570.248 657.014L713.003 460.746C716.475 455.972 721.795 452.881 727.662 452.227L1037.21 417.764C1042.2 417.209 1047.23 418.46 1051.38 421.292L1284.52 580.45C1290.61 584.611 1294.08 591.666 1293.64 599.033L1280.44 822.405C1280.01 829.772 1275.74 836.37 1269.2 839.784L1018.93 970.378C1014.48 972.701 1009.34 973.352 1004.45 972.212L701.112 901.533C695.363 900.194 690.444 896.497 687.558 891.347ZM565.422 681.588C560.649 673.072 561.27 662.556 567.013 654.661L709.768 458.393C713.901 452.71 720.235 449.03 727.219 448.252L1036.77 413.789C1042.71 413.127 1048.69 414.617 1053.63 417.988L1286.77 577.146C1294.03 582.1 1298.15 590.498 1297.64 599.269L1284.44 822.641C1283.92 831.411 1278.83 839.266 1271.05 843.33L1020.78 973.924C1015.48 976.69 1009.36 977.465 1003.54 976.108L700.204 905.429C693.361 903.834 687.504 899.433 684.069 893.303L565.422 681.588Z",
    fill: "url(#paint36_linear_52_1127)"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.550725,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M658.989 878.943L553.183 663.042C549.593 655.716 550.57 646.973 555.691 640.621L706.58 453.43C710.293 448.824 715.775 445.998 721.68 445.646L1028.29 427.37C1033.33 427.069 1038.31 428.595 1042.31 431.667L1263.59 601.301C1269.43 605.779 1272.5 612.987 1271.68 620.301L1246.99 841.041C1246.17 848.355 1241.59 854.707 1234.9 857.783L981.617 974.341C977.03 976.451 971.837 976.839 966.988 975.433L671.996 889.871C666.315 888.223 661.592 884.255 658.989 878.943ZM549.591 664.802C545.317 656.08 546.481 645.673 552.576 638.111L703.466 450.919C707.885 445.437 714.412 442.072 721.442 441.653L1028.05 423.377C1034.05 423.019 1039.98 424.835 1044.75 428.492L1266.02 598.126C1272.97 603.457 1276.63 612.039 1275.66 620.746L1250.97 841.485C1249.99 850.192 1244.53 857.754 1236.57 861.417L983.289 977.974C977.829 980.487 971.646 980.949 965.874 979.274L670.882 893.712C664.118 891.751 658.496 887.027 655.397 880.704L549.591 664.802Z",
    fill: "url(#paint37_linear_52_1127)"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.565217,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M631.269 866.374L538.411 647.043C535.247 639.57 536.673 630.942 542.073 624.883L700.545 447.078C704.49 442.652 710.121 440.1 716.049 440.051L1018.87 437.56C1023.95 437.518 1028.87 439.317 1032.72 442.622L1241.68 621.929C1247.25 626.708 1249.92 634.049 1248.72 641.289L1212.79 858.812C1211.59 866.052 1206.7 872.143 1199.89 874.877L944.359 977.441C939.648 979.332 934.412 979.452 929.619 977.78L643.689 878.014C638.091 876.061 633.58 871.833 631.269 866.374ZM534.728 648.603C530.961 639.706 532.658 629.435 539.087 622.222L697.559 444.416C702.255 439.148 708.959 436.109 716.016 436.051L1018.84 433.56C1024.88 433.51 1030.74 435.651 1035.33 439.587L1244.29 618.894C1250.92 624.583 1254.1 633.321 1252.67 641.941L1216.73 859.464C1215.31 868.084 1209.49 875.335 1201.38 878.589L945.849 981.153C940.241 983.404 934.007 983.548 928.301 981.557L642.371 881.791C635.707 879.466 630.337 874.432 627.585 867.933L534.728 648.603Z",
    fill: "url(#paint38_linear_52_1127)"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.57971,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M604.397 853.686L524.552 631.684C521.82 624.089 523.684 615.599 529.346 609.846L694.839 441.704C699.007 437.469 704.774 435.198 710.71 435.454L1008.95 448.304C1014.05 448.523 1018.9 450.593 1022.58 454.126L1218.83 642.285C1224.11 647.349 1226.37 654.798 1224.81 661.946L1177.88 875.685C1176.31 882.832 1171.14 888.648 1164.22 891.034L907.205 979.689C902.38 981.353 897.113 981.203 892.39 979.266L616.19 866.009C610.693 863.755 606.408 859.277 604.397 853.686ZM520.788 633.038C517.536 623.996 519.754 613.889 526.495 607.041L691.988 438.898C696.95 433.857 703.815 431.153 710.882 431.458L1009.12 444.307C1015.2 444.569 1020.96 447.033 1025.35 451.239L1221.6 639.397C1227.88 645.427 1230.58 654.294 1228.71 662.804L1181.79 876.542C1179.92 885.051 1173.76 891.975 1165.52 894.815L908.51 983.47C902.765 985.452 896.495 985.273 890.872 982.967L614.673 869.71C608.128 867.026 603.027 861.696 600.633 855.04L520.788 633.038Z",
    fill: "url(#paint39_linear_52_1127)"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.594203,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M578.369 840.928L511.556 617.01C509.261 609.317 511.552 600.989 517.459 595.553L689.404 437.318C693.785 433.285 699.673 431.303 705.602 431.863L998.496 459.569C1003.61 460.053 1008.36 462.391 1011.87 466.143L1195.06 662.318C1200.03 667.651 1201.89 675.186 1199.95 682.221L1142.35 891.629C1140.41 898.664 1134.96 904.19 1127.96 906.226L870.202 981.096C865.272 982.528 859.988 982.105 855.35 979.906L589.498 853.9C584.117 851.349 580.072 846.634 578.369 840.928ZM507.723 618.153C504.991 608.996 507.718 599.081 514.751 592.61L686.695 434.374C691.911 429.574 698.921 427.213 705.978 427.881L998.872 455.587C1004.96 456.162 1010.62 458.947 1014.79 463.413L1197.98 659.588C1203.91 665.937 1206.11 674.907 1203.81 683.282L1146.2 892.69C1143.9 901.065 1137.41 907.644 1129.07 910.067L871.317 984.938C865.449 986.642 859.159 986.138 853.636 983.521L587.785 857.514C581.379 854.478 576.563 848.865 574.536 842.072L507.723 618.153Z",
    fill: "url(#paint40_linear_52_1127)"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.608696,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M553.179 828.145L499.375 603.06C497.519 595.296 500.225 587.151 506.359 582.042L684.179 433.925C688.764 430.105 694.759 428.417 700.664 429.283L987.482 471.323C992.591 472.072 997.245 474.676 1000.55 478.639L1170.39 681.983C1175.06 687.566 1176.5 695.165 1174.2 702.068L1106.23 906.619C1103.94 913.522 1098.24 918.746 1091.16 920.428L833.393 981.679C828.37 982.873 823.083 982.174 818.542 979.716L563.607 841.731C558.358 838.89 554.566 833.95 553.179 828.145ZM495.484 603.99C493.275 594.747 496.497 585.051 503.799 578.968L681.619 430.852C687.078 426.304 694.214 424.295 701.244 425.325L988.062 467.365C994.144 468.256 999.684 471.357 1003.62 476.075L1173.46 679.419C1179.01 686.065 1180.73 695.111 1178 703.329L1110.03 907.881C1107.3 916.098 1100.51 922.318 1092.08 924.32L834.318 985.571C828.338 986.992 822.044 986.16 816.638 983.234L561.703 845.249C555.455 841.867 550.94 835.986 549.288 829.075L495.484 603.99Z",
    fill: "url(#paint41_linear_52_1127)"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.623188,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M528.816 815.383L487.956 589.871C486.541 582.062 489.649 574.122 495.991 569.349L679.105 431.53C683.885 427.932 689.972 426.544 695.838 427.713L975.892 483.53C980.985 484.546 985.522 487.412 988.626 491.577L1144.88 701.236C1149.21 707.05 1150.24 714.688 1147.59 721.441L1069.6 920.631C1066.96 927.383 1061.02 932.294 1053.89 933.621L796.825 981.454C791.719 982.405 786.442 981.429 782.013 978.716L538.51 829.546C533.409 826.421 529.883 821.269 528.816 815.383ZM484.02 590.585C482.335 581.287 486.036 571.835 493.585 566.153L676.7 428.334C682.39 424.051 689.636 422.399 696.62 423.791L976.674 479.608C982.738 480.816 988.138 484.229 991.833 489.186L1148.08 698.845C1153.24 705.767 1154.46 714.861 1151.32 722.899L1073.33 922.089C1070.18 930.128 1063.11 935.974 1054.62 937.553L797.557 985.387C791.478 986.518 785.196 985.357 779.924 982.127L536.42 832.957C530.348 829.237 526.15 823.103 524.88 816.096L484.02 590.585Z",
    fill: "url(#paint42_linear_52_1127)"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.637681,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M505.27 802.686L477.245 577.479C476.271 569.65 479.768 561.934 486.298 557.506L674.125 430.131C679.087 426.765 685.251 425.682 691.064 427.153L963.707 496.158C968.772 497.44 973.177 500.564 976.062 504.92L1118.54 720.034C1122.53 726.06 1123.14 733.715 1120.16 740.299L1032.53 933.646C1029.54 940.23 1023.38 944.816 1016.22 945.787L760.539 980.442C755.361 981.144 750.108 979.891 745.805 976.927L514.196 817.387C509.258 813.986 506.01 808.636 505.27 802.686ZM473.276 577.973C472.116 568.652 476.279 559.467 484.053 554.195L671.88 426.82C677.787 422.814 685.126 421.524 692.045 423.275L964.688 492.28C970.718 493.806 975.963 497.525 979.397 502.711L1121.87 717.825C1126.62 724.999 1127.35 734.112 1123.8 741.95L1036.17 935.298C1032.62 943.135 1025.28 948.595 1016.76 949.751L761.076 984.406C754.912 985.242 748.659 983.749 743.536 980.221L511.927 820.681C506.049 816.632 502.182 810.263 501.3 803.18L473.276 577.973Z",
    fill: "url(#paint43_linear_52_1127)"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.652174,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M482.525 790.097L467.19 565.914C466.654 558.089 470.524 550.619 477.223 546.541L669.179 429.723C674.313 426.599 680.539 425.824 686.283 427.595L950.911 509.169C955.934 510.717 960.194 514.094 962.849 518.631L1091.42 738.337C1095.05 744.555 1095.25 752.205 1091.94 758.602L995.058 945.649C991.744 952.047 985.383 956.299 978.205 956.914L724.577 978.665C719.339 979.114 714.124 977.582 709.96 974.373L490.654 805.295C485.895 801.626 482.935 796.093 482.525 790.097ZM463.199 566.187C462.562 556.872 467.168 547.978 475.144 543.124L667.1 426.306C673.211 422.587 680.624 421.664 687.461 423.772L952.089 505.346C958.07 507.19 963.141 511.209 966.302 516.611L1094.87 736.317C1099.2 743.72 1099.43 752.826 1095.49 760.441L998.61 947.489C994.665 955.105 987.092 960.167 978.547 960.9L724.919 982.65C718.683 983.185 712.474 981.362 707.518 977.541L488.212 808.463C482.546 804.095 479.023 797.508 478.534 790.37L463.199 566.187Z",
    fill: "url(#paint44_linear_52_1127)"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.666667,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M460.566 777.658L457.732 555.202C457.632 547.408 461.858 540.2 468.707 536.48L664.21 430.301C669.503 427.426 675.777 426.963 681.435 429.029L937.489 522.528C942.458 524.342 946.559 527.965 948.973 532.672L1063.55 756.111C1066.82 762.5 1066.61 770.12 1062.98 776.314L957.265 956.629C953.633 962.823 947.089 966.733 939.914 966.994L688.978 976.146C683.692 976.339 678.528 974.53 674.518 971.08L467.869 793.311C463.302 789.382 460.642 783.682 460.566 777.658ZM453.732 555.252C453.614 545.974 458.644 537.394 466.798 532.965L662.301 426.786C668.603 423.364 676.071 422.812 682.807 425.272L938.861 518.77C944.777 520.93 949.659 525.243 952.532 530.847L1067.11 754.286C1071.01 761.892 1070.75 770.963 1066.43 778.337L960.715 958.652C956.392 966.026 948.602 970.68 940.06 970.992L689.124 980.143C682.831 980.373 676.683 978.219 671.909 974.112L465.26 796.343C459.824 791.666 456.657 784.88 456.566 777.709L453.732 555.252Z",
    fill: "url(#paint45_linear_52_1127)"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.681159,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M439.374 765.41L448.815 545.367C449.148 537.628 453.712 530.701 460.691 527.343L659.161 431.854C664.602 429.236 670.907 429.087 676.466 431.445L923.432 536.199C928.332 538.277 932.261 542.14 934.422 547.005L1034.98 773.32C1037.88 779.859 1037.26 787.427 1033.32 793.401L919.211 966.579C915.274 972.553 908.566 976.112 901.411 976.022L653.782 972.913C648.459 972.846 643.36 970.76 639.517 967.077L445.825 781.473C441.466 777.295 439.115 771.443 439.374 765.41ZM444.819 545.195C445.214 535.983 450.648 527.736 458.957 523.739L657.427 428.249C663.905 425.133 671.41 424.955 678.028 427.762L924.993 532.516C930.828 534.991 935.504 539.589 938.078 545.38L1038.63 771.696C1042.09 779.48 1041.35 788.489 1036.66 795.602L922.551 968.779C917.864 975.892 909.878 980.129 901.361 980.022L653.732 976.913C647.395 976.833 641.325 974.35 636.749 969.965L443.058 784.361C437.868 779.388 435.069 772.421 435.378 765.239L444.819 545.195Z",
    fill: "url(#paint46_linear_52_1127)"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.695652,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M418.928 753.392L440.382 536.428C441.139 528.77 446.024 522.14 453.114 519.147L653.976 434.367C659.553 432.013 665.873 432.18 671.318 434.824L908.726 550.144C913.546 552.485 917.288 556.58 919.188 561.59L1005.74 789.933C1008.27 796.6 1007.24 804.093 1003.01 809.833L880.957 975.494C876.728 981.233 869.876 984.436 862.76 983.998L619.025 968.994C613.677 968.664 608.657 966.303 604.993 962.394L424.504 769.819C420.364 765.402 418.332 759.415 418.928 753.392ZM436.401 536.035C437.303 526.918 443.118 519.025 451.558 515.462L652.421 430.681C659.059 427.879 666.584 428.078 673.065 431.226L910.474 546.546C916.212 549.333 920.667 554.208 922.928 560.172L1009.48 788.516C1012.49 796.452 1011.27 805.373 1006.23 812.206L884.177 977.866C879.143 984.699 870.986 988.511 862.514 987.99L618.779 972.986C612.412 972.594 606.436 969.783 602.074 965.129L421.585 772.554C416.658 767.297 414.238 760.169 414.947 752.998L436.401 536.035Z",
    fill: "url(#paint47_linear_52_1127)"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.710145,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M399.206 741.639L432.374 528.402C433.549 520.849 438.735 514.531 445.915 511.906L648.601 437.823C654.3 435.74 660.621 436.223 665.936 439.149L893.367 564.327C898.092 566.928 901.635 571.247 903.262 576.39L975.886 805.923C978.029 812.695 976.603 820.091 972.096 825.582L842.568 983.374C838.061 988.864 831.084 991.704 824.024 990.922L584.74 964.418C579.379 963.824 574.452 961.19 570.98 957.062L403.885 758.384C399.979 753.74 398.273 747.635 399.206 741.639ZM428.421 527.788C429.82 518.795 435.995 511.274 444.542 508.149L647.228 434.066C654.012 431.586 661.537 432.162 667.865 435.645L895.295 560.823C900.921 563.919 905.139 569.061 907.076 575.183L979.7 804.716C982.25 812.778 980.553 821.583 975.188 828.12L845.66 985.912C840.295 992.448 831.989 995.829 823.584 994.898L584.3 968.393C577.918 967.686 572.052 964.551 567.919 959.637L400.823 760.958C396.174 755.43 394.143 748.162 395.253 741.025L428.421 527.788Z",
    fill: "url(#paint48_linear_52_1127)"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.724638,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M380.183 730.189L424.732 521.302C426.316 513.877 431.784 507.884 439.034 505.63L642.983 442.202C648.791 440.396 655.097 441.196 660.269 444.397L877.347 578.711C881.965 581.569 885.297 586.104 886.643 591.365L945.456 821.262C947.21 828.118 945.393 835.396 940.624 840.623L804.106 990.224C799.336 995.451 792.255 997.924 785.268 996.804L550.962 959.218C545.6 958.358 540.78 955.454 537.513 951.116L383.947 747.203C380.288 742.344 378.915 736.138 380.183 730.189ZM420.82 520.468C422.705 511.628 429.215 504.494 437.846 501.81L641.796 438.383C648.71 436.232 656.216 437.185 662.374 440.995L879.452 575.31C884.949 578.711 888.915 584.11 890.518 590.373L949.331 820.271C951.419 828.432 949.257 837.096 943.578 843.319L807.061 992.92C801.382 999.143 792.952 1002.09 784.634 1000.75L550.328 963.167C543.945 962.143 538.207 958.686 534.318 953.522L380.751 749.609C376.395 743.825 374.761 736.437 376.271 729.355L420.82 520.468Z",
    fill: "url(#paint49_linear_52_1127)"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.73913,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M361.834 719.076L417.398 515.137C419.38 507.862 425.109 502.209 432.409 500.324L637.07 447.482C642.974 445.958 649.249 447.075 654.264 450.543L860.663 593.26C865.161 596.37 868.268 601.112 869.324 606.477L914.496 835.93C915.857 842.846 913.658 849.984 908.641 854.934L765.631 996.051C760.614 1001 753.448 1003.11 746.551 1001.65L517.72 953.427C512.369 952.3 507.669 949.13 504.62 944.591L364.665 736.308C361.264 731.247 360.231 724.958 361.834 719.076ZM413.538 514.085C415.898 505.425 422.719 498.695 431.409 496.451L636.07 443.609C643.098 441.795 650.568 443.124 656.539 447.253L862.938 589.97C868.292 593.672 871.991 599.317 873.249 605.704L918.42 835.158C920.041 843.391 917.424 851.888 911.451 857.782L768.441 998.899C762.468 1004.79 753.937 1007.3 745.726 1005.57L516.895 957.341C510.525 955.999 504.93 952.225 501.3 946.822L361.345 738.539C357.296 732.514 356.067 725.027 357.975 718.024L413.538 514.085Z",
    fill: "url(#paint50_linear_52_1127)"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.753623,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M344.131 708.329L410.312 509.911C412.681 502.81 418.651 497.506 425.981 495.99L630.813 453.637C636.799 452.399 643.027 453.831 647.871 457.558L843.314 607.936C847.679 611.294 850.55 616.232 851.308 621.686L883.052 849.906C884.019 856.859 881.448 863.836 876.2 868.499L727.206 1000.87C721.958 1005.53 714.727 1007.26 707.936 1005.48L485.043 947.081C479.716 945.685 475.15 942.253 472.33 937.523L346.016 725.731C342.885 720.481 342.197 714.128 344.131 708.329ZM406.518 508.645C409.338 500.191 416.444 493.878 425.171 492.073L630.003 449.72C637.129 448.246 644.543 449.951 650.311 454.388L845.754 604.766C850.949 608.763 854.367 614.642 855.27 621.135L887.014 849.355C888.165 857.633 885.104 865.938 878.856 871.489L729.863 1003.86C723.615 1009.41 715.007 1011.47 706.922 1009.35L484.029 950.95C477.687 949.289 472.252 945.203 468.894 939.572L342.58 727.78C338.853 721.53 338.034 713.967 340.336 707.064L406.518 508.645Z",
    fill: "url(#paint51_linear_52_1127)"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.768116,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M327.043 697.981L403.417 505.627C406.16 498.72 412.348 493.777 419.689 492.629L624.164 460.638C630.218 459.691 636.383 461.435 641.044 465.413L825.3 622.703C829.519 626.304 832.141 631.428 832.595 636.956L851.17 863.174C851.743 870.142 848.81 876.937 843.348 881.3L688.888 1004.68C683.426 1009.05 676.151 1010.41 669.482 1008.31L452.957 940.216C447.666 938.552 443.248 934.862 440.668 929.952L327.972 715.499C325.121 710.075 324.782 703.676 327.043 697.981ZM399.7 504.151C402.964 495.929 410.331 490.044 419.071 488.677L623.545 456.686C630.753 455.558 638.093 457.635 643.641 462.371L827.897 619.661C832.919 623.948 836.041 630.048 836.582 636.629L855.157 862.847C855.838 871.141 852.347 879.231 845.844 884.426L691.385 1007.81C684.882 1013 676.221 1014.62 668.282 1012.13L451.757 944.032C445.458 942.051 440.199 937.658 437.127 931.813L324.431 717.36C321.037 710.903 320.634 703.285 323.326 696.505L399.7 504.151Z",
    fill: "url(#paint52_linear_52_1127)"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.782609,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M310.543 688.058L396.655 502.282C399.757 495.591 406.141 491.017 413.474 490.233L617.076 468.453C623.185 467.8 629.273 469.854 633.737 474.074L806.624 637.524C810.684 641.363 813.047 646.662 813.19 652.248L818.899 875.719C819.077 882.678 815.795 889.273 810.136 893.327L650.737 1007.52C645.078 1011.58 637.778 1012.56 631.246 1010.16L421.487 932.868C416.244 930.936 411.987 926.995 409.658 921.915L310.506 705.641C307.946 700.057 307.959 693.631 310.543 688.058ZM393.026 500.6C396.719 492.634 404.319 487.189 413.049 486.255L616.651 464.476C623.923 463.698 631.171 466.143 636.485 471.168L809.371 634.618C814.205 639.188 817.019 645.496 817.188 652.146L822.898 875.617C823.109 883.902 819.202 891.752 812.465 896.579L653.066 1010.77C646.329 1015.6 637.639 1016.77 629.863 1013.91L420.104 936.622C413.863 934.322 408.795 929.629 406.022 923.582L306.87 707.308C303.822 700.66 303.838 693.011 306.913 686.376L393.026 500.6Z",
    fill: "url(#paint53_linear_52_1127)"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.797101,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M294.596 678.586L389.969 499.873C393.415 493.416 399.973 489.219 407.278 488.795L609.508 477.051C615.656 476.693 621.651 479.053 625.907 483.506L787.289 652.366C791.179 656.436 793.271 661.898 793.097 667.525L786.284 887.532C786.07 894.459 782.451 900.834 776.614 904.57L612.807 1009.4C606.97 1013.14 599.665 1013.75 593.285 1011.05L390.655 925.078C385.472 922.88 381.389 918.692 379.323 913.454L293.589 696.181C291.328 690.453 291.697 684.02 294.596 678.586ZM386.44 497.989C390.542 490.303 398.349 485.307 407.047 484.802L609.276 473.057C616.595 472.632 623.733 475.442 628.798 480.742L790.181 649.602C794.811 654.448 797.303 660.95 797.095 667.649L790.282 887.656C790.027 895.903 785.719 903.492 778.77 907.939L614.963 1012.77C608.014 1017.22 599.318 1017.95 591.723 1014.73L389.093 928.761C382.923 926.143 378.062 921.157 375.602 914.923L289.868 697.65C287.177 690.829 287.615 683.172 291.067 676.703L386.44 497.989Z",
    fill: "url(#paint54_linear_52_1127)"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.811594,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M279.171 669.589L383.302 498.389C387.074 492.186 393.783 488.372 401.043 488.303L601.416 486.393C607.59 486.334 613.477 488.996 617.512 493.67L767.302 667.191C771.009 671.486 772.821 677.098 772.325 682.75L753.373 898.604C752.77 905.477 748.829 911.614 742.832 915.024L575.154 1010.35C569.156 1013.76 561.867 1014 555.653 1011.01L360.479 916.885C355.369 914.42 351.473 909.993 349.679 904.61L277.191 687.143C275.238 681.285 275.962 674.865 279.171 669.589ZM379.884 496.311C384.376 488.926 392.363 484.386 401.005 484.303L601.377 482.393C608.728 482.323 615.737 485.492 620.54 491.056L770.329 664.578C774.743 669.69 776.9 676.372 776.309 683.1L757.358 898.954C756.639 907.135 751.949 914.442 744.809 918.501L577.131 1013.83C569.991 1017.89 561.313 1018.18 553.916 1014.61L358.742 920.488C352.658 917.554 348.02 912.283 345.884 905.875L273.396 688.408C271.071 681.434 271.934 673.791 275.754 667.511L379.884 496.311Z",
    fill: "url(#paint55_linear_52_1127)"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.826087,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M264.234 661.089L376.598 497.821C380.681 491.889 387.518 488.462 394.713 488.742L592.762 496.443C598.948 496.684 604.712 499.642 608.516 504.526L746.67 681.967C750.184 686.479 751.705 692.229 750.882 697.889L720.213 908.931C719.226 915.726 714.979 921.609 708.84 924.685L537.83 1010.39C531.691 1013.47 524.436 1013.35 518.402 1010.07L330.977 908.329C325.951 905.601 322.255 900.941 320.743 895.426L261.28 678.548C259.643 672.577 260.724 666.189 264.234 661.089ZM373.303 495.553C378.163 488.491 386.303 484.412 394.869 484.745L592.917 492.446C600.282 492.733 607.144 496.254 611.672 502.069L749.827 679.51C754.009 684.882 755.82 691.727 754.841 698.464L724.171 909.506C722.996 917.595 717.94 924.599 710.632 928.261L539.622 1013.97C532.314 1017.63 523.678 1017.49 516.494 1013.59L329.069 911.844C323.086 908.597 318.686 903.049 316.886 896.483L257.423 679.605C255.474 672.498 256.761 664.892 260.939 658.821L373.303 495.553Z",
    fill: "url(#paint56_linear_52_1127)"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.84058,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M249.75 653.104L369.806 498.151C374.179 492.507 381.121 489.471 388.235 490.093L583.51 507.161C589.694 507.702 595.321 510.95 598.882 516.033L725.405 696.66C728.713 701.382 729.934 707.255 728.782 712.904L686.851 918.51C685.486 925.205 680.948 930.817 674.688 933.554L500.885 1009.55C494.625 1012.29 487.424 1011.81 481.582 1008.27L302.164 899.451C297.235 896.462 293.751 891.577 292.53 885.943L245.827 670.413C244.512 664.347 245.949 658.011 249.75 653.104ZM366.644 495.701C371.85 488.982 380.115 485.368 388.583 486.108L583.859 503.176C591.22 503.82 597.919 507.686 602.158 513.738L728.682 694.365C732.619 699.986 734.073 706.979 732.701 713.704L690.77 919.309C689.145 927.279 683.744 933.96 676.291 937.219L502.488 1013.22C495.035 1016.48 486.463 1015.91 479.508 1011.69L300.09 902.871C294.221 899.312 290.074 893.497 288.621 886.79L241.918 671.261C240.353 664.039 242.063 656.495 246.588 650.654L366.644 495.701Z",
    fill: "url(#paint57_linear_52_1127)"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.855072,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M235.685 645.652L362.872 499.364C367.516 494.021 374.54 491.379 381.555 492.334L573.627 518.505C579.793 519.345 585.269 522.876 588.578 528.147L703.518 711.236C706.608 716.16 707.52 722.143 706.036 727.764L653.333 927.342C651.597 933.915 646.787 939.241 640.424 941.635L464.369 1007.87C458.006 1010.27 450.878 1009.43 445.24 1005.63L274.051 890.293C269.231 887.045 265.972 881.945 265.051 876.205L230.798 662.758C229.812 656.614 231.602 650.348 235.685 645.652ZM359.853 496.739C365.382 490.379 373.744 487.233 382.095 488.371L574.167 514.541C581.508 515.542 588.027 519.746 591.966 526.02L706.906 709.11C710.585 714.971 711.67 722.094 709.904 728.785L657.2 928.363C655.134 936.188 649.407 942.529 641.832 945.379L465.777 1011.62C458.202 1014.47 449.717 1013.47 443.005 1008.95L271.816 893.611C266.077 889.744 262.198 883.672 261.101 876.839L226.848 663.392C225.674 656.077 227.805 648.618 232.666 643.028L359.853 496.739Z",
    fill: "url(#paint58_linear_52_1127)"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.869565,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M222.002 638.747L355.745 501.436C360.64 496.41 367.723 494.161 374.621 495.442L563.082 530.43C569.216 531.569 574.527 535.377 577.574 540.822L681.021 725.666C683.884 730.781 684.478 736.861 682.66 742.434L619.704 935.431C617.607 941.86 612.542 946.886 606.096 948.933L428.325 1005.39C421.88 1007.43 414.843 1006.25 409.42 1002.21L246.649 880.898C241.948 877.395 238.926 872.086 238.313 866.256L216.16 655.596C215.508 649.391 217.648 643.217 222.002 638.747ZM352.879 498.645C358.707 492.662 367.139 489.984 375.352 491.509L563.812 526.498C571.115 527.853 577.437 532.387 581.064 538.868L684.511 723.712C687.92 729.802 688.627 737.039 686.463 743.674L623.507 936.671C621.01 944.325 614.98 950.309 607.307 952.746L429.536 1009.2C421.863 1011.64 413.485 1010.23 407.03 1005.42L244.259 884.105C238.663 879.935 235.065 873.615 234.335 866.674L212.182 656.014C211.405 648.627 213.954 641.277 219.136 635.956L352.879 498.645Z",
    fill: "url(#paint59_linear_52_1127)"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.884058,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M208.665 632.402L348.376 504.346C353.502 499.648 360.62 497.792 367.387 499.388L551.845 542.894C557.934 544.33 563.066 548.406 565.842 554.012L657.929 739.917C660.554 745.216 660.823 751.375 658.67 756.883L586.01 942.783C583.561 949.048 578.26 953.76 571.751 955.458L392.798 1002.13C386.29 1003.83 379.362 1002.31 374.165 998.036L219.964 871.307C215.396 867.552 212.622 862.046 212.324 856.14L201.881 648.94C201.566 642.693 204.053 636.629 208.665 632.402ZM345.674 501.397C351.775 495.805 360.249 493.595 368.305 495.495L552.763 539C560.012 540.71 566.121 545.562 569.427 552.236L661.514 738.141C664.638 744.449 664.959 751.783 662.396 758.339L589.735 944.239C586.82 951.697 580.509 957.308 572.76 959.329L393.808 1006C386.059 1008.02 377.812 1006.21 371.625 1001.13L217.424 874.397C211.986 869.928 208.684 863.372 208.329 856.341L197.886 649.142C197.511 641.704 200.472 634.486 205.962 629.454L345.674 501.397Z",
    fill: "url(#paint60_linear_52_1127)"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.898551,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M195.638 626.627L340.72 508.065C346.053 503.707 353.184 502.241 359.804 504.142L539.893 555.847C545.922 557.578 550.861 561.914 553.36 567.667L634.259 753.96C636.636 759.432 636.572 765.657 634.085 771.08L552.293 949.406C549.505 955.486 543.987 959.874 537.435 961.221L357.828 998.148C351.277 999.496 344.475 997.641 339.514 993.154L194.002 861.562C189.577 857.561 187.063 851.866 187.088 845.9L187.927 642.801C187.953 636.529 190.781 630.596 195.638 626.627ZM338.189 504.968C344.538 499.78 353.027 498.034 360.907 500.297L540.997 552.003C548.174 554.063 554.054 559.225 557.029 566.074L637.928 752.367C640.757 758.881 640.682 766.292 637.721 772.748L555.929 951.074C552.609 958.312 546.04 963.535 538.24 965.139L358.634 1002.07C350.834 1003.67 342.737 1001.46 336.831 996.121L191.319 864.529C186.051 859.765 183.058 852.986 183.088 845.884L183.927 642.785C183.958 635.318 187.325 628.255 193.107 623.53L338.189 504.968Z",
    fill: "url(#paint61_linear_52_1127)"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.913043,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M182.885 621.43L332.731 512.566C338.249 508.557 345.37 507.478 351.828 509.671L527.202 569.245C533.157 571.268 537.892 575.853 540.105 581.74L610.029 767.768C612.147 773.404 611.745 779.677 608.924 784.996L518.598 955.313C515.482 961.188 509.767 965.24 503.192 966.237L323.453 993.478C316.878 994.475 310.219 992.298 305.502 987.61L168.764 851.708C164.494 847.464 162.251 841.591 162.604 835.581L174.264 637.188C174.633 630.909 177.797 625.127 182.885 621.43ZM330.379 509.33C336.949 504.557 345.426 503.272 353.115 505.884L528.489 565.457C535.578 567.866 541.215 573.324 543.849 580.333L613.773 766.361C616.295 773.07 615.816 780.538 612.458 786.87L522.131 957.187C518.422 964.181 511.619 969.005 503.791 970.191L324.052 997.433C316.225 998.619 308.298 996.028 302.683 990.447L165.945 854.545C160.861 849.492 158.191 842.501 158.611 835.346L170.271 636.953C170.711 629.479 174.477 622.595 180.534 618.194L330.379 509.33Z",
    fill: "url(#paint62_linear_52_1127)"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.927536,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M170.37 616.817L324.366 517.816C330.046 514.164 337.136 513.467 343.419 515.942L513.755 583.037C519.622 585.348 524.14 590.174 526.061 596.18L585.258 781.313C587.109 787.101 586.362 793.407 583.209 798.603L484.964 960.517C481.535 966.168 475.645 969.875 469.066 970.522L289.707 988.166C283.128 988.813 276.629 986.325 272.164 981.45L144.252 841.784C140.148 837.303 138.186 831.263 138.873 825.225L160.861 632.106C161.574 625.841 165.065 620.227 170.37 616.817ZM322.203 514.451C328.965 510.104 337.405 509.274 344.885 512.22L515.221 579.316C522.206 582.067 527.584 587.811 529.871 594.962L589.068 780.095C591.271 786.986 590.382 794.493 586.629 800.678L488.384 962.591C484.301 969.319 477.29 973.732 469.458 974.503L290.098 992.147C282.267 992.917 274.53 989.955 269.215 984.152L141.302 844.486C136.416 839.151 134.081 831.961 134.899 824.773L156.886 631.654C157.735 624.195 161.892 617.512 168.206 613.452L322.203 514.451Z",
    fill: "url(#paint63_linear_52_1127)"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.942029,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M158.055 612.791L315.586 523.782C321.405 520.494 328.441 520.172 334.536 522.915L499.533 597.176C505.299 599.771 509.589 604.826 511.212 610.937L559.966 794.57C561.54 800.5 560.443 806.822 556.962 811.874L451.432 965.033C447.705 970.443 441.661 973.796 435.098 974.097L256.622 982.258C250.059 982.558 243.735 979.77 239.529 974.724L120.461 831.835C116.534 827.121 114.864 820.926 115.89 814.877L147.681 627.561C148.739 621.327 152.55 615.902 158.055 612.791ZM313.618 520.299C320.545 516.385 328.922 516.002 336.177 519.268L501.175 593.528C508.039 596.618 513.146 602.635 515.078 609.91L563.832 793.544C565.706 800.603 564.399 808.129 560.255 814.143L454.726 967.303C450.288 973.743 443.094 977.735 435.281 978.092L256.804 986.254C248.992 986.611 241.463 983.292 236.456 977.284L117.388 834.395C112.713 828.784 110.725 821.409 111.947 814.208L143.738 626.892C144.997 619.471 149.533 613.012 156.087 609.309L313.618 520.299Z",
    fill: "url(#paint64_linear_52_1127)"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.956522,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M145.905 609.354L306.353 530.427C312.287 527.508 319.248 527.555 325.142 530.552L484.525 611.61C490.176 614.484 494.226 619.757 495.546 625.958L534.174 807.514C535.464 813.574 534.011 819.894 530.206 824.783L418.04 968.881C414.031 974.032 407.855 977.025 401.329 976.982L224.226 975.802C217.699 975.758 211.564 972.683 207.624 967.48L97.388 821.9C93.6478 816.96 92.2797 810.622 93.6497 804.579L134.694 623.554C136.096 617.371 140.216 612.153 145.905 609.354ZM304.588 526.838C311.651 523.363 319.939 523.418 326.956 526.987L486.339 608.045C493.066 611.466 497.888 617.744 499.458 625.126L538.087 806.682C539.622 813.896 537.893 821.42 533.362 827.24L421.196 971.338C416.424 977.47 409.072 981.034 401.302 980.982L224.199 979.802C216.429 979.75 209.125 976.089 204.435 969.894L94.1991 824.315C89.7465 818.434 88.1177 810.888 89.7487 803.695L130.793 622.67C132.462 615.309 137.367 609.096 144.139 605.765L304.588 526.838Z",
    fill: "url(#paint65_linear_52_1127)"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.971014,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M133.884 606.505L296.633 537.715C302.657 535.169 309.523 535.574 315.206 538.812L468.72 626.291C474.243 629.438 478.044 634.918 479.056 641.194L507.907 820.123C508.903 826.302 507.091 832.603 502.966 837.309L384.825 972.082C380.552 976.957 374.266 979.585 367.795 979.202L192.545 968.847C186.073 968.464 180.141 965.114 176.471 959.77L75.025 812.021C71.4826 806.862 70.4259 800.392 72.1428 794.373L121.866 620.087C123.61 613.974 128.029 608.98 133.884 606.505ZM295.075 534.03C302.247 530.999 310.421 531.482 317.186 535.337L470.701 622.816C477.276 626.562 481.8 633.086 483.005 640.557L511.856 819.486C513.042 826.842 510.885 834.343 505.974 839.945L387.833 974.718C382.746 980.522 375.263 983.65 367.559 983.195L192.309 972.84C184.605 972.384 177.542 968.396 173.174 962.034L71.7275 814.286C67.5103 808.144 66.2523 800.441 68.2963 793.276L118.019 618.99C120.095 611.712 125.356 605.767 132.327 602.821L295.075 534.03Z",
    fill: "url(#paint66_linear_52_1127)"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.985507,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M121.958 604.241L286.392 545.605C292.482 543.433 299.234 544.188 304.694 547.652L452.111 641.167C457.494 644.581 461.034 650.255 461.735 656.59L481.186 832.375C481.881 838.66 479.708 844.924 475.269 849.427L351.822 974.656C347.303 979.24 340.93 981.499 334.533 980.783L161.601 961.442C155.203 960.726 149.487 957.116 146.092 951.646L53.3623 802.239C50.0278 796.866 49.2917 790.277 51.3585 784.301L109.164 617.157C111.248 611.133 115.954 606.382 121.958 604.241ZM285.048 541.837C292.299 539.252 300.337 540.151 306.837 544.274L454.254 637.789C460.661 641.854 464.876 648.609 465.711 656.15L485.162 831.935C485.99 839.417 483.402 846.874 478.117 852.235L354.671 977.464C349.291 982.922 341.704 985.61 334.088 984.758L161.156 965.417C153.54 964.565 146.735 960.267 142.694 953.755L49.9637 804.348C45.994 797.952 45.1177 790.108 47.5782 782.994L105.384 615.85C107.864 608.679 113.467 603.022 120.614 600.473L285.048 541.837Z",
    fill: "url(#paint67_linear_52_1127)"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M110.091 602.557L275.602 554.056C281.735 552.259 288.353 553.352 293.581 557.027L434.695 656.188C439.924 659.863 443.195 665.718 443.583 672.097L454.038 844.251C454.425 850.63 451.887 856.838 447.141 861.118L319.065 976.628C314.319 980.909 307.882 982.795 301.577 981.753L131.413 953.638C125.108 952.597 119.62 948.74 116.503 943.161L32.389 792.593C29.2721 787.013 28.8656 780.318 31.2843 774.403L96.559 614.762C98.9777 608.846 103.958 604.354 110.091 602.557ZM274.477 550.218C281.778 548.078 289.656 549.38 295.881 553.754L436.995 652.916C443.22 657.29 447.114 664.261 447.575 671.855L458.03 844.008C458.492 851.602 455.47 858.993 449.82 864.089L321.744 979.599C316.094 984.694 308.431 986.94 300.925 985.699L130.761 957.585C123.255 956.345 116.722 951.754 113.011 945.112L28.8969 794.543C25.1864 787.901 24.7024 779.931 27.5818 772.889L92.8565 613.248C95.7359 606.206 101.665 600.858 108.967 598.718L274.477 550.218Z",
    fill: "url(#paint68_linear_52_1127)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_52_1127",
    x1: 2113.46,
    y1: 1078.05,
    x2: 1390.3,
    y2: 1100.65,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8DD7EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.505208,
    stopColor: "#3F7286"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2B3074"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_52_1127",
    x1: 2063.85,
    y1: 1095.67,
    x2: 1344.63,
    y2: 1079.96,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8DD7EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.505208,
    stopColor: "#3F7286"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2B3074"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_52_1127",
    x1: 2013.73,
    y1: 1111.69,
    x2: 1300.48,
    y2: 1058.15,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8DD7EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.505208,
    stopColor: "#3F7286"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2B3074"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_52_1127",
    x1: 1963.19,
    y1: 1126.1,
    x2: 1257.89,
    y2: 1035.31,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8DD7EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.505208,
    stopColor: "#3F7286"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2B3074"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_52_1127",
    x1: 1912.31,
    y1: 1138.9,
    x2: 1216.9,
    y2: 1011.53,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8DD7EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.505208,
    stopColor: "#3F7286"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2B3074"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_52_1127",
    x1: 1861.2,
    y1: 1150.07,
    x2: 1177.56,
    y2: 986.909,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8DD7EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.505208,
    stopColor: "#3F7286"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2B3074"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_52_1127",
    x1: 1809.94,
    y1: 1159.63,
    x2: 1139.89,
    y2: 961.553,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8DD7EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.505208,
    stopColor: "#3F7286"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2B3074"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_52_1127",
    x1: 1758.61,
    y1: 1167.57,
    x2: 1103.94,
    y2: 935.56,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8DD7EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.505208,
    stopColor: "#3F7286"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2B3074"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_52_1127",
    x1: 1707.3,
    y1: 1173.92,
    x2: 1069.71,
    y2: 909.033,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8DD7EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.505208,
    stopColor: "#3F7286"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2B3074"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_52_1127",
    x1: 1656.1,
    y1: 1178.7,
    x2: 1037.24,
    y2: 882.074,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8DD7EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.505208,
    stopColor: "#3F7286"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2B3074"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_52_1127",
    x1: 1605.1,
    y1: 1181.91,
    x2: 1006.52,
    y2: 854.786,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8DD7EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.505208,
    stopColor: "#3F7286"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2B3074"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_52_1127",
    x1: 1554.36,
    y1: 1183.6,
    x2: 977.561,
    y2: 827.272,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8DD7EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.505208,
    stopColor: "#3F7286"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2B3074"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_52_1127",
    x1: 1503.98,
    y1: 1183.78,
    x2: 950.364,
    y2: 799.635,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8DD7EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.505208,
    stopColor: "#3F7286"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2B3074"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_52_1127",
    x1: 1454.02,
    y1: 1182.51,
    x2: 924.922,
    y2: 771.976,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8DD7EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.505208,
    stopColor: "#3F7286"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2B3074"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_52_1127",
    x1: 1404.57,
    y1: 1179.8,
    x2: 901.219,
    y2: 744.395,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8DD7EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.505208,
    stopColor: "#3F7286"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2B3074"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_52_1127",
    x1: 1355.69,
    y1: 1175.71,
    x2: 879.238,
    y2: 716.992,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8DD7EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.505208,
    stopColor: "#3F7286"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2B3074"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_52_1127",
    x1: 1307.45,
    y1: 1170.28,
    x2: 858.955,
    y2: 689.864,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8DD7EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.505208,
    stopColor: "#3F7286"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2B3074"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_52_1127",
    x1: 1259.92,
    y1: 1163.55,
    x2: 840.34,
    y2: 663.107,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8DD7EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.505208,
    stopColor: "#3F7286"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2B3074"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_52_1127",
    x1: 1213.15,
    y1: 1155.59,
    x2: 823.357,
    y2: 636.813,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8DD7EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.505208,
    stopColor: "#3F7286"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2B3074"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_52_1127",
    x1: 1167.21,
    y1: 1146.45,
    x2: 807.967,
    y2: 611.072,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8DD7EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.505208,
    stopColor: "#3F7286"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2B3074"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_52_1127",
    x1: 1122.16,
    y1: 1136.18,
    x2: 794.124,
    y2: 585.972,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8DD7EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.505208,
    stopColor: "#3F7286"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2B3074"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_52_1127",
    x1: 1078.03,
    y1: 1124.84,
    x2: 781.779,
    y2: 561.597,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8DD7EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.505208,
    stopColor: "#3F7286"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2B3074"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_52_1127",
    x1: 1034.88,
    y1: 1112.5,
    x2: 770.877,
    y2: 538.028,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8DD7EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.505208,
    stopColor: "#3F7286"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2B3074"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_52_1127",
    x1: 992.755,
    y1: 1099.22,
    x2: 761.359,
    y2: 515.341,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8DD7EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.505208,
    stopColor: "#3F7286"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2B3074"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_52_1127",
    x1: 951.689,
    y1: 1085.06,
    x2: 753.163,
    y2: 493.61,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8DD7EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.505208,
    stopColor: "#3F7286"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2B3074"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_52_1127",
    x1: 911.717,
    y1: 1070.1,
    x2: 746.221,
    y2: 472.904,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8DD7EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.505208,
    stopColor: "#3F7286"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2B3074"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear_52_1127",
    x1: 872.873,
    y1: 1054.4,
    x2: 740.466,
    y2: 453.288,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8DD7EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.505208,
    stopColor: "#3F7286"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2B3074"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint27_linear_52_1127",
    x1: 835.181,
    y1: 1038.03,
    x2: 735.821,
    y2: 434.82,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8DD7EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.505208,
    stopColor: "#3F7286"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2B3074"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint28_linear_52_1127",
    x1: 798.665,
    y1: 1021.05,
    x2: 732.211,
    y2: 417.557,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8DD7EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.505208,
    stopColor: "#3F7286"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2B3074"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint29_linear_52_1127",
    x1: 763.342,
    y1: 1003.56,
    x2: 729.557,
    y2: 401.55,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8DD7EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.505208,
    stopColor: "#3F7286"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2B3074"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint30_linear_52_1127",
    x1: 729.228,
    y1: 985.599,
    x2: 727.777,
    y2: 386.844,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8DD7EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.505208,
    stopColor: "#3F7286"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2B3074"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint31_linear_52_1127",
    x1: 696.333,
    y1: 967.256,
    x2: 726.787,
    y2: 373.479,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8DD7EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.505208,
    stopColor: "#3F7286"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2B3074"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint32_linear_52_1127",
    x1: 664.661,
    y1: 948.597,
    x2: 726.501,
    y2: 361.49,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8DD7EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.505208,
    stopColor: "#3F7286"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2B3074"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint33_linear_52_1127",
    x1: 634.216,
    y1: 929.693,
    x2: 726.833,
    y2: 350.909,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8DD7EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.505208,
    stopColor: "#3F7286"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2B3074"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint34_linear_52_1127",
    x1: 604.996,
    y1: 910.614,
    x2: 727.694,
    y2: 341.759,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8DD7EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.505208,
    stopColor: "#3F7286"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2B3074"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint35_linear_52_1127",
    x1: 576.994,
    y1: 891.427,
    x2: 728.994,
    y2: 334.06,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8DD7EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.505208,
    stopColor: "#3F7286"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2B3074"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint36_linear_52_1127",
    x1: 550.201,
    y1: 872.201,
    x2: 730.644,
    y2: 327.826,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8DD7EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.505208,
    stopColor: "#3F7286"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2B3074"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint37_linear_52_1127",
    x1: 524.605,
    y1: 853.003,
    x2: 732.554,
    y2: 323.066,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8DD7EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.505208,
    stopColor: "#3F7286"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2B3074"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint38_linear_52_1127",
    x1: 500.186,
    y1: 833.896,
    x2: 734.634,
    y2: 319.782,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8DD7EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.505208,
    stopColor: "#3F7286"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2B3074"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint39_linear_52_1127",
    x1: 476.926,
    y1: 814.945,
    x2: 736.793,
    y2: 317.973,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8DD7EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.505208,
    stopColor: "#3F7286"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2B3074"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint40_linear_52_1127",
    x1: 454.8,
    y1: 796.21,
    x2: 738.943,
    y2: 317.631,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8DD7EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.505208,
    stopColor: "#3F7286"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2B3074"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint41_linear_52_1127",
    x1: 433.783,
    y1: 777.751,
    x2: 740.996,
    y2: 318.743,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8DD7EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.505208,
    stopColor: "#3F7286"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2B3074"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint42_linear_52_1127",
    x1: 413.842,
    y1: 759.625,
    x2: 742.865,
    y2: 321.293,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8DD7EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.505208,
    stopColor: "#3F7286"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2B3074"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint43_linear_52_1127",
    x1: 394.947,
    y1: 741.885,
    x2: 744.465,
    y2: 325.256,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8DD7EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.505208,
    stopColor: "#3F7286"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2B3074"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint44_linear_52_1127",
    x1: 377.061,
    y1: 724.585,
    x2: 745.713,
    y2: 330.605,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8DD7EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.505208,
    stopColor: "#3F7286"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2B3074"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint45_linear_52_1127",
    x1: 360.145,
    y1: 707.773,
    x2: 746.526,
    y2: 337.307,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8DD7EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.505208,
    stopColor: "#3F7286"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2B3074"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint46_linear_52_1127",
    x1: 344.161,
    y1: 691.497,
    x2: 746.828,
    y2: 345.325,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8DD7EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.505208,
    stopColor: "#3F7286"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2B3074"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint47_linear_52_1127",
    x1: 329.064,
    y1: 675.8,
    x2: 746.54,
    y2: 354.617,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8DD7EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.505208,
    stopColor: "#3F7286"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2B3074"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint48_linear_52_1127",
    x1: 314.811,
    y1: 660.723,
    x2: 745.591,
    y2: 365.136,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8DD7EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.505208,
    stopColor: "#3F7286"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2B3074"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint49_linear_52_1127",
    x1: 301.355,
    y1: 646.303,
    x2: 743.91,
    y2: 376.833,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8DD7EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.505208,
    stopColor: "#3F7286"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2B3074"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint50_linear_52_1127",
    x1: 288.646,
    y1: 632.575,
    x2: 741.429,
    y2: 389.654,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8DD7EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.505208,
    stopColor: "#3F7286"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2B3074"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint51_linear_52_1127",
    x1: 276.638,
    y1: 619.571,
    x2: 738.088,
    y2: 403.539,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8DD7EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.505208,
    stopColor: "#3F7286"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2B3074"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint52_linear_52_1127",
    x1: 265.277,
    y1: 607.318,
    x2: 733.826,
    y2: 418.429,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8DD7EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.505208,
    stopColor: "#3F7286"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2B3074"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint53_linear_52_1127",
    x1: 254.515,
    y1: 595.841,
    x2: 728.587,
    y2: 434.256,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8DD7EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.505208,
    stopColor: "#3F7286"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2B3074"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint54_linear_52_1127",
    x1: 244.297,
    y1: 585.162,
    x2: 722.322,
    y2: 450.955,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8DD7EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.505208,
    stopColor: "#3F7286"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2B3074"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint55_linear_52_1127",
    x1: 234.57,
    y1: 575.299,
    x2: 714.983,
    y2: 468.453,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8DD7EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.505208,
    stopColor: "#3F7286"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2B3074"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint56_linear_52_1127",
    x1: 225.281,
    y1: 566.266,
    x2: 706.527,
    y2: 486.679,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8DD7EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.505208,
    stopColor: "#3F7286"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2B3074"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint57_linear_52_1127",
    x1: 216.378,
    y1: 558.076,
    x2: 696.918,
    y2: 505.556,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8DD7EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.505208,
    stopColor: "#3F7286"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2B3074"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint58_linear_52_1127",
    x1: 207.806,
    y1: 550.736,
    x2: 686.122,
    y2: 525.008,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8DD7EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.505208,
    stopColor: "#3F7286"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2B3074"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint59_linear_52_1127",
    x1: 199.511,
    y1: 544.251,
    x2: 674.111,
    y2: 544.954,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8DD7EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.505208,
    stopColor: "#3F7286"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2B3074"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint60_linear_52_1127",
    x1: 191.442,
    y1: 538.623,
    x2: 660.862,
    y2: 565.315,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8DD7EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.505208,
    stopColor: "#3F7286"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2B3074"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint61_linear_52_1127",
    x1: 183.546,
    y1: 533.851,
    x2: 646.357,
    y2: 586.008,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8DD7EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.505208,
    stopColor: "#3F7286"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2B3074"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint62_linear_52_1127",
    x1: 175.772,
    y1: 529.93,
    x2: 630.582,
    y2: 606.951,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8DD7EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.505208,
    stopColor: "#3F7286"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2B3074"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint63_linear_52_1127",
    x1: 168.068,
    y1: 526.852,
    x2: 613.53,
    y2: 628.06,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8DD7EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.505208,
    stopColor: "#3F7286"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2B3074"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint64_linear_52_1127",
    x1: 160.386,
    y1: 524.609,
    x2: 595.197,
    y2: 649.254,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8DD7EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.505208,
    stopColor: "#3F7286"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2B3074"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint65_linear_52_1127",
    x1: 152.678,
    y1: 523.184,
    x2: 575.586,
    y2: 670.446,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8DD7EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.505208,
    stopColor: "#3F7286"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2B3074"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint66_linear_52_1127",
    x1: 144.897,
    y1: 522.565,
    x2: 554.703,
    y2: 691.555,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8DD7EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.505208,
    stopColor: "#3F7286"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2B3074"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint67_linear_52_1127",
    x1: 136.997,
    y1: 522.731,
    x2: 532.561,
    y2: 712.498,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8DD7EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.505208,
    stopColor: "#3F7286"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2B3074"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint68_linear_52_1127",
    x1: 128.937,
    y1: 523.662,
    x2: 509.177,
    y2: 733.192,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8DD7EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.505208,
    stopColor: "#3F7286"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2B3074"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOctagon2);
export default __webpack_public_path__ + "static/media/Octagon2.32ba237bf840d94275d81a8ca29c3e40.svg";
export { ForwardRef as ReactComponent };